<template>
    <div class="columns is-mobile is-centered has-background-primary p-2"  v-if="props.vista=='completa'">
        <h1 class="title is-4 has-text-white"><i class="fas fa-arrow-right-from-bracket"></i> &nbsp; PREVENTIVO</h1>
    </div>

    <div class="box" @submit.prevent="" v-if="formAttivo">

        <div class="columns is-mobile">
            <div class="column">
                <div class="field buttons">
                    <button class="button is-light" v-if="props.vista=='completa'" @click="bAnnulla" :disabled="!preventivoDaAggiornare">Annulla</button>
                    <button class="button is-light" v-if="props.vista=='ridotta'" @click="bChiudi">Chiudi</button>
                    <button class="button is-primary" @click="bSalva" :disabled="!preventivoDaAggiornare">Salva</button>
                </div>
            </div>
            <div class="column" v-if="props.vista=='completa' && schermoLargo">
                <p>
                    <a @click="gestisciSelezioneElemento({tipo: 'cliente', idCliente: props.idCliente})" title="Vai al cliente">
                        <i class="fas fa-user"></i> &nbsp; {{ generaStringaCliente(props.idCliente) }}
                    </a>
                </p>
            </div>
            <div class="column" v-if="props.vista=='completa' && schermoLargo">
                <p>
                    <a @click="gestisciSelezioneElemento({tipo: 'lead', idCliente: props.idCliente, idLead: props.idLead})" title="Vai al lead">
                        <i class="fas fa-arrow-right-from-bracket"></i> &nbsp; {{ dbClienti[props.idCliente]?.leads?.[props.idLead]?.oggetto }}
                    </a>
                </p>
            </div>
            <div class="column" v-if="schermoLargo">
                <div class="field buttons is-right">
                    <button class="button is-danger" @click="bElimina" v-if="idPreventivoSelezionato!=-1 && permettiElimina">Elimina</button>
                </div>
            </div>
        </div>

        <div class="blocco-scroll">

            <div class="columns is-mobile" v-if="!schermoLargo">
                <div class="column" v-if="props.vista=='completa' && !schermoLargo">
                    <p>
                        <a @click="gestisciSelezioneElemento({tipo: 'cliente', idCliente: props.idCliente})" title="Vai al cliente">
                            <i class="fas fa-user"></i> &nbsp; {{ generaStringaCliente(props.idCliente) }}
                        </a>
                    </p>
                </div>
                <div class="column" v-if="props.vista=='completa' && !schermoLargo">
                    <p>
                        <a @click="gestisciSelezioneElemento({tipo: 'lead', idCliente: props.idCliente, idLead: props.idLead})" title="Vai al lead">
                            <i class="fas fa-arrow-right-from-bracket"></i> &nbsp; {{ dbClienti[props.idCliente]?.leads?.[props.idLead]?.oggetto }}
                        </a>
                    </p>
                </div>
            </div>

            <div class="tabs">
                <ul>
                    <li :class="{'is-active': statoInterfaccia.formPreventivoTab == 1}">
                        <a @click="bSelezionaTAb(1)">
                            <span>Dati generali</span>
                        </a>
                    </li>
                    <li :class="{'is-active': statoInterfaccia.formPreventivoTab == 2}">
                        <a @click="bSelezionaTAb(2)">
                            <span>Computo</span>
                        </a>
                    </li>
                    <li :class="{'is-active': statoInterfaccia.formPreventivoTab == 3}">
                        <a @click="bSelezionaTAb(3)">
                            <span>Sconti</span>
                        </a>
                    </li>
                </ul>
            </div>

            <div class="columns" v-if="!(resetInCorso)&&statoInterfaccia.formPreventivoTab==1">
                <div class="column is-1">
                    <CampoNumero @valoreCambiato="preventivoModifica"
                        :valore=preventivoSelezionato.numero
                        identificativo="numero"
                        etichetta="Numero"
                        formato="Flat"
                        allineamento="Centro"
                        tipo="Intero"
                        tipoBottone="numeroPreventivo"/>
                </div>
                <div class="column is-2">
                    <CampoData @valoreCambiato="preventivoModifica"
                        :valore=preventivoSelezionato.data
                        identificativo="data"
                        etichetta="Data"/>
                </div>
                <div class="column is-5">
                    <div class="field">
                        <label class="label">Oggetto</label>
                        <div class="control">
                            <input class="input" type="text" v-model="preventivoSelezionato.oggetto"  @change="preventivoModifica(preventivoSelezionato.oggetto, 'oggetto')">
                        </div>
                    </div>
                </div>
                <div class="column is-2">
                    <CampoNumero @valoreCambiato="preventivoModifica"
                        :valore=preventivoSelezionato.importo
                        identificativo="importo"
                        etichetta="Importo"
                        :decimali = 2
                        tipo="Decimale"/>
                </div>
                <div class="column is-1">
                    <CampoCheckbox @valoreCambiato="preventivoModifica"
                        :valore=preventivoSelezionato.inviato
                        identificativo="inviato"
                        etichetta="Inviato"/>
                </div>
                <div class="column is-1">
                    <CampoCheckbox @valoreCambiato="preventivoModifica"
                        :valore=preventivoSelezionato.attivo
                        identificativo="attivo"
                        etichetta="Attivo"/>
                </div>
            </div>
            <div class="columns" v-if="!(resetInCorso)&&statoInterfaccia.formPreventivoTab==1">
                <div class="column is-3">
                    <div class="field">
                        <CampoTendina @valoreCambiato="(valore)=>preventivoModifica(valore, 'iva')"
                            :valore=preventivoSelezionato.iva
                            idTendina="preventivo.iva"
                            etichetta="Iva"/>
                    </div>
                </div>
                <div class="column is-2">
                    <div class="field">
                        <label class="label">Validità</label>
                        <div class="control">
                            <input class="input" type="text" v-model="preventivoSelezionato.validita"  @change="preventivoModifica(preventivoSelezionato.validita, 'validita')">
                        </div>
                    </div>
                </div>
                <div class="column is-3">
                    <div class="field">
                        <label class="label">Condizioni di pagamento</label>
                        <div class="control">
                            <input class="input" type="text" v-model="preventivoSelezionato.pagamento"  @change="preventivoModifica(preventivoSelezionato.pagamento, 'pagamento')">
                        </div>
                    </div>
                </div>
                <div class="column is-4">
                    <div class="field">
                        <label class="label">Riferimento</label>
                        <div class="control">
                            <input class="input" type="text" v-model="preventivoSelezionato.riferimento"  @change="preventivoModifica(preventivoSelezionato.riferimento, 'riferimento')">
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns" v-if="!(resetInCorso)&&statoInterfaccia.formPreventivoTab==1">
                <div class="column is-2">
                    <div class="field">
                        <label class="label">&nbsp;</label>
                        <button class="button is-primary is-outlined is-fullwidth" @click="scaricaXlsxPreventivo()" :disabled="preventivoDaAggiornare">
                            Scarica preventivo
                        </button>
                    </div>
                </div>
                <div class="column is-2">
                    <div class="field">
                        <label class="label">&nbsp;</label>
                        <button class="button is-primary is-outlined is-fullwidth" @click="scaricaXlsxOrdine()" :disabled="preventivoDaAggiornare">
                            Crea ordine
                        </button>
                    </div>
                </div>
                <div class="column is-2">
                    <div class="field">
                        <label class="label">&nbsp;</label>
                        <button class="button is-primary is-outlined is-fullwidth" @click="scaricaXlsxConsuntivo()" :disabled="preventivoDaAggiornare">
                            Crea consuntivo
                        </button>
                    </div>
                </div>
            </div>
            <div class="columns" v-if="!(resetInCorso)&&statoInterfaccia.formPreventivoTab==2">
                    <table class="table mx-auto is-fullwidth">
                        <thead>
                            <tr>
                            <th class="has-text-centered">
                                <button class="button is-small is-primary is-outlined" @click="bCopia(-1, 0)">
                                    <span class="icon" title="Copia preventivo"><i class="fas fa-copy"></i></span>
                                </button>
                                <button class="button is-small is-primary is-outlined" @click="bIncolla(null, null)" :disabled="!('vociPreventivo' in copiaTrasporto) || preventivoSelezionato.inviato">
                                    <span class="icon" title="Incolla alla fine del preventivo"><i class="fas fa-paste"></i></span>
                                </button>
                            </th>
                            <th></th>
                            <th class="has-text-centered">Codice</th>
                            <th>Descrizione</th>
                            <th class="has-text-centered">U.M.</th>
                            <th class="has-text-centered">Quantità</th>
                            <th class="has-text-centered">Prezzo</th>
                            <th></th>
                            <th class="has-text-centered">Sconto</th>
                            <th class="has-text-centered">Totale</th>
                            <th class="has-text-centered">Costi</th>
                            <th class="has-text-centered">N</th>
                            <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(ev, index) in elencoVociPreventivo[numSezioneVoceSelezionata]" :key="index">
                            <tr>
                                <td class="has-text-centered" v-if="ev.tipo=='Articolo' || ev.tipo=='Titolo' || ev.tipo=='Nota'">
                                    <button class="button is-small is-primary is-outlined"
                                            @click="numVoceSelezionata=index; azioneVoceSelezionata='modifica'"
                                            :disabled="preventivoSelezionato.inviato">
                                        <span class="icon" title="Modifica"><i class="fas fa-arrow-right-from-bracket"></i></span>
                                    </button>
                                    <button class="button is-small is-primary is-outlined"
                                            @click="numVoceSelezionata=index; azioneVoceSelezionata='inserisci'"
                                            :disabled="preventivoSelezionato.inviato">
                                        <span class="icon" title="Inserisci nella riga sotto"><i class="fas fa-plus"></i></span>
                                    </button>
                                    <button class="button is-small is-primary is-outlined"
                                            @click="bCopia(numSezioneVoceSelezionata, index)">
                                        <span class="icon" title="Copia questa voce"><i class="fas fa-copy"></i></span>
                                    </button>
                                    <button class="button is-small is-primary is-outlined"
                                            @click="bIncolla(numSezioneVoceSelezionata, index)"
                                            :disabled="!('vociPreventivo' in copiaTrasporto) || preventivoSelezionato.inviato">
                                        <span class="icon" title="Incolla nella riga sotto"><i class="fas fa-paste"></i></span>
                                    </button>
                                    <button class="button is-small is-primary is-outlined" v-if="ev.tipo=='Titolo'"
                                            @click="bEliminaVocePreventivo(numSezioneVoceSelezionata, index)"
                                            :disabled="numSezioneVoceSelezionata==0 && (elencoVociPreventivo.length==1 || elencoVociPreventivo[numSezioneVoceSelezionata].length>2) || preventivoSelezionato.inviato">
                                        <span class="icon"><i class="fas fa-trash-can"></i></span>
                                    </button>
                                    <button class="button is-small is-primary is-outlined" v-if="ev.tipo!='Titolo'"
                                            @click="bEliminaVocePreventivo(numSezioneVoceSelezionata, index)"
                                            :disabled="numSezioneVoceSelezionata==0 && index==0 || preventivoSelezionato.inviato">
                                        <span class="icon"><i class="fas fa-trash-can"></i></span>
                                    </button>
                                </td>
                                <td  v-if="ev.tipo!='Articolo' && ev.tipo!='Titolo' && ev.tipo!='Nota'"></td>

                                <td class="has-text-centered">{{ index + 1 }}</td>

                                <td class="has-text-centered" v-if="ev.tipo == 'Nota'"></td>
                                <td v-if="ev.tipo == 'Nota'" colspan="9" v-html="generaTestoMultiriga(ev.descrizione)"></td>

                                <td class="has-text-centered" v-if="ev.tipo == 'Articolo' && !ev.beneSignificativo">{{ ev.codice }}</td>
                                <td class="has-text-centered is-primary" title="Bene significativo al prezzo" v-if="ev.tipo == 'Articolo' && ev.beneSignificativo=='Prezzo'">{{ ev.codice }}</td>
                                <td class="has-text-centered is-primary" title="Bene significativo al costo" v-if="ev.tipo == 'Articolo' && ev.beneSignificativo=='Costo'">{{ ev.codice }}</td>
                                <td v-if="ev.tipo == 'Articolo'" v-html="generaTestoMultiriga(ev.descrizione)"></td>
                                <td class="has-text-centered" v-if="ev.tipo == 'Articolo'">{{ ev.unita }}</td>
                                <td class="has-text-centered" v-if="ev.tipo == 'Articolo'">{{ ev.quantita }}</td>
                                <td class="has-text-right" v-if="ev.tipo == 'Articolo'">
                                    {{ generaStringa(generaPrezzoUnitario(ev), '0,00') }}
                                </td>
                                <td class="has-text-centered" v-if="ev.tipo == 'Articolo'">
                                    <span v-if="dbListini?.[ev.listino]?.informazioni?.attivo === false" class="icon has-text-danger" title="Listino non attivo">
                                        <i class="fas fa-ban"></i>
                                    </span>
                                </td>
                                <td class="has-text-centered" v-if="ev.tipo == 'Articolo' && ev.scVisibile">
                                    {{ testoSconti(ev, true) }}
                                </td>
                                <td class="has-text-centered has-text-info" v-if="ev.tipo == 'Articolo' && !ev.scVisibile">
                                    {{ testoSconti(ev, true) }}
                                </td>
                                <td class="has-text-right" v-if="ev.tipo == 'Articolo'">
                                    {{ generaStringa(prezzoVocePreventivo(ev, preventivoSelezionato.sconti[ev.tipoRicaricoSconto])*ev.quantita, '0,00') }}
                                </td>
                                <td class="has-text-right" v-if="ev.tipo == 'Articolo'">
                                    {{ generaStringa(costoVocePreventivo(ev, preventivoSelezionato.sconti[ev.tipoRicaricoSconto])*ev.quantita, '0,00') }}
                                </td>
                                <td class="has-text-centered" v-if="ev.tipo == 'Articolo'">
                                    <ComponenteIcona nome="Nota" :visibileSempre="false" :descrizione="ev.note" />
                                </td>

                                <td class="is-light has-text-centered" v-if="ev.tipo == 'Titolo'"><strong>{{ ev.codice }}</strong></td>
                                <td class="is-light" v-if="ev.tipo == 'Titolo'" v-html="'<strong>'+generaTestoMultiriga(ev.titolo+((ev.sottotitolo)?'</strong></td>\n\n'+ev.sottotitolo:''))"></td>
                                <td colspan="5" class="is-light has-text-centered" v-if="ev.tipo == 'Titolo'">
                                    <button class="button is-small is-primary is-outlined" @click="bCopia(numSezioneVoceSelezionata, -1)">
                                        <span class="icon" title="Copia sezione"><i class="fas fa-copy"></i></span>
                                    </button>
                                    &nbsp;&nbsp;
                                    <button class="button is-small is-primary is-outlined" @click="bCambiaSezione(-1)"
                                    :disabled="numSezioneVoceSelezionata==0">
                                        <span class="icon" title="Sezione precedente"><i class="fas fa-arrow-left"></i></span>
                                    </button>
                                    &nbsp;&nbsp; Sezione {{ numSezioneVoceSelezionata + 1 }} di {{ elencoVociPreventivo.length }} &nbsp;&nbsp;
                                    <button class="button is-small is-primary is-outlined" @click="bCambiaSezione(1)"
                                    :disabled="numSezioneVoceSelezionata==(elencoVociPreventivo.length - 1)">
                                        <span class="icon" title="Sezione successiva"><i class="fas fa-arrow-right"></i></span>
                                    </button>
                                </td>
                                <td colspan="3" class="is-light" v-if="ev.tipo == 'Titolo'">
                                </td>

                                <td v-if="ev.tipo == 'Totale'"></td>
                                <td colspan="6" v-if="ev.tipo == 'Totale'"><strong>{{ ev.descrizione }}</strong></td>
                                <td class="has-text-right" v-if="ev.tipo == 'Totale'"><strong>{{ generaStringa(ev.importo, '0,00') }}</strong></td>
                                <td class="has-text-right" v-if="ev.tipo == 'Totale'"><strong>{{ generaStringa(ev.costo, '0,00') }}</strong></td>
                                <td v-if="ev.tipo == 'Totale'"></td>
                                <td v-if="ev.tipo == 'Totale'"></td>

                                <td v-if="ev.tipo == 'Iva'"></td>
                                <td colspan="6" v-if="ev.tipo == 'Iva'">{{ ev.descrizione }}</td>
                                <td class="has-text-right" v-if="ev.tipo == 'Iva'">{{ generaStringa(ev.importo, '0,00') }}</td>
                                <td v-if="ev.tipo == 'Iva'"></td>
                                <td v-if="ev.tipo == 'Iva'"></td>
                                <td v-if="ev.tipo == 'Iva'"></td>

                                <td v-if="ev.tipo == 'TotaleIC'"></td>
                                <td colspan="6" v-if="ev.tipo == 'TotaleIC'"><strong>{{ ev.descrizione }}</strong></td>
                                <td class="has-text-right" v-if="ev.tipo == 'TotaleIC'"><strong>{{ generaStringa(ev.importo, '0,00') }}</strong></td>
                                <td v-if="ev.tipo == 'TotaleIC'"></td>
                                <td v-if="ev.tipo == 'TotaleIC'"></td>
                                <td v-if="ev.tipo == 'TotaleIC'"></td>

                                <td class="has-text-centered" v-if="ev.tipo=='Titolo'">
                                    <button class="button is-small is-primary is-outlined" title="Sposta l'intera sezione"
                                            @click="bSpostaVocePreventivo(numSezioneVoceSelezionata, index, -1, true)"
                                            :disabled="numSezioneVoceSelezionata==0 || preventivoSelezionato.inviato">
                                        <span class="icon"><i class="fas fa-arrow-left"></i></span>
                                    </button>
                                    <button class="button is-small is-primary is-outlined" title="Sposta l'intera sezione"
                                            @click="bSpostaVocePreventivo(numSezioneVoceSelezionata, index, 1, true)"
                                            :disabled="( numSezioneVoceSelezionata==(elencoVociPreventivo.length-1) ) || preventivoSelezionato.inviato">
                                        <span class="icon"><i class="fas fa-arrow-right"></i></span>
                                    </button>
                                </td>

                                <td class="has-text-centered" v-if="ev.tipo=='Articolo' || ev.tipo=='Nota'">
                                    <button class="button is-small is-primary is-outlined"
                                            @click="bSpostaVocePreventivo(numSezioneVoceSelezionata, index, -1, false)"
                                            :disabled="numSezioneVoceSelezionata==0 && index<=1 || preventivoSelezionato.inviato">
                                        <span class="icon"><i class="fas fa-arrow-up"></i></span>
                                    </button>
                                    <button class="button is-small is-primary is-outlined"
                                            @click="bSpostaVocePreventivo(numSezioneVoceSelezionata, index, 1, false)"
                                            :disabled="(numSezioneVoceSelezionata==(elencoVociPreventivo.length-1) && index==(elencoVociPreventivo[numSezioneVoceSelezionata].length-2))||(numSezioneVoceSelezionata==0 && index==0) || preventivoSelezionato.inviato">
                                        <span class="icon"><i class="fas fa-arrow-down"></i></span>
                                    </button>
                                </td>
                            </tr>
                            </template>
                            <tr>
                                <td class="is-light"></td>
                                <td class="is-light"></td>
                                <td class="is-light"></td>
                                <td  class="is-light" colspan="6"><strong>TOTALE OFFERTA</strong></td>
                                <td class="is-light has-text-right"><strong>{{ generaStringa(prezzoTotale, '0,00') }}</strong></td>
                                <td class="is-light has-text-right"><strong>{{ generaStringa(costoTotale, '0,00') }}</strong></td>
                                <td class="is-light"></td>
                                <td class="is-light"></td>
                            </tr>
                        </tbody>
                    </table>
            </div>

            <div class="columns" v-if="!(resetInCorso)&&statoInterfaccia.formPreventivoTab==3">
                <table class="table mx-auto">
                    <thead>
                        <tr>
                            <th v-if="mostraInfoSviluppo"></th>
                            <th>Descrizione</th>
                            <th>Ricarico/sconto</th>
                            <th>Fonte</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(sc, index) in elencoScontiPreventivo" :key="sc">
                            <td v-if="mostraInfoSviluppo">{{ index }}</td>
                            <td>
                                <div class="field">
                                    <div class="control">
                                        <input class="input" type="text" v-model="sc.descrizione" @change="scontoPreventivoModifica('modifica', leggiInfoDBRaw(sc)?.id, 'descrizione', sc.descrizione)"
                                            :disabled="index==0 || index==1 || preventivoSelezionato.inviato">
                                    </div>
                                </div>
                            </td>
                            <td>
                                <CampoRicarico @valoreCambiato="(valore, etichetta) => scontoPreventivoModifica('modifica', leggiInfoDBRaw(sc)?.id, etichetta, valore)"
                                    :valore=sc.aliquote
                                    :sola-lettura="index==0 || preventivoSelezionato.inviato"
                                    identificativo="aliquote"/>
                            </td>
                            <td>
                                <CampoTendina @valoreCambiato="(valore) => scontoPreventivoModifica('modifica', leggiInfoDBRaw(sc)?.id, 'fonte', valore)"
                                    :valore=sc.fonte
                                    :disabilitato="index==0 || index==1 || preventivoSelezionato.inviato"
                                    idTendina="ricarico.fonte"/>
                            </td>
                            <td class="has-text-centered">
                                <button class="button is-small is-primary is-outlined" @click="scontoPreventivoModifica('elimina', leggiInfoDBRaw(sc)?.id, '', null)"
                                    :disabled="index==0 || index==1 || !voceRicaricoScontoEliminabile(leggiInfoDBRaw(sc)?.id) || preventivoDaAggiornare || preventivoSelezionato.inviato">
                                    <span class="icon"><i class="fas fa-trash-can"></i></span>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>
                                <button class="button is-small is-primary is-outlined" @click="scontoPreventivoModifica('aggiungi', null)" :disabled="preventivoSelezionato.inviato">
                                    <span class="icon"><i class="fas fa-plus"></i></span>
                                </button>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>

        </div>

        <FormVocePreventivoModale
            @elementoModificato="vocePreventivoModifica"
            :azione="azioneVoceSelezionata"
            :vocePreventivo="elencoVociPreventivo[numSezioneVoceSelezionata][numVoceSelezionata]"
            :elencoValoriRicaricoSconto="preventivoSelezionato.sconti"
            :tipo-disabilitato="(numSezioneVoceSelezionata==0 && numVoceSelezionata==0 && azioneVoceSelezionata=='modifica')?true:false"
            v-if="numVoceSelezionata!=null"/>

        <MessaggioModale @selezionato="bComandoModale"
            :confMessaggioModale=messaggioModale
            v-if="messaggioModale"/>

    </div>

</template>

<script setup>
    import CampoData from "./CampoData.vue";
    import CampoNumero from "./CampoNumero.vue";
    import CampoCheckbox from "./CampoCheckbox.vue";
    import CampoRicarico from "./CampoRicarico.vue";
    import CampoTendina from "./CampoTendina.vue";
    import MessaggioModale from "./MessaggioModale.vue";
    import FormVocePreventivoModale from "./FormVocePreventivoModale.vue";
    import ComponenteIcona from "./ComponenteIcona.vue";
    // FIX: Aggiunto watch per reattività asincrona
    import { defineProps, defineEmits, ref, nextTick, watch, onBeforeUnmount } from "vue";
    import { dbClienti, dbContatti, dbListini, salvaPreventivoInFirestore, eliminaPreventivoInFirestore, eliminaScontoDaPreventivoInFirestore, aggiungiInfoDB, leggiInfoDBRaw } from "./../code/gestioneDB";
    // FIX: Importata generaStringaCliente
    import { generaIdPreventivo, statoInterfaccia, generaStringa, mostraInfoSviluppo, clonaOggetto, prezzoVocePreventivo, costoVocePreventivo, dataDaTimestamp, permettiElimina, copiaTrasporto, formattaTelefono, schermoLargo, generaStringaCliente } from "./../code/utilita";
    import * as XLSX from 'xlsx-js-style';

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        idPreventivo: {
            type: Number,
            default: -1
        },
        idLead: {
            type: Number,
            required: true
        },
        idCliente: {
            type: Number,
            required: true
        },
        sezioneVocePreventivo: {
            type: Number,
            default: 0
        },
        vista: {                    // completa, ridotta
            type: String,
            default: 'completa'
        }
    });
    const emit = defineEmits(['elementoSelezionato', 'modificaElementoInCorso']);

    // VARIABILI DEL COMPONENTE
    // FIX: preventivoSelezionato inizia come {} invece di null
    const preventivoSelezionato = ref({});               
    const preventivoDaAggiornare = ref(null);              
    const messaggioModale = ref(null);                     
    // FIX: Sicurezza iniziale
    const idPreventivoSelezionato = ref(props.idPreventivo || -1);
    const resetInCorso = ref(false);
    const formAttivo = ref(true);               
    const elencoVociPreventivo = ref([]);       
    const numSezioneVoceSelezionata = ref(0);       
    const numVoceSelezionata = ref(null);       
    const elencoScontiPreventivo = ref([]);
    const azioneVoceSelezionata = ref(null);    
    const beniSignificativi = ref([]);          
    const prezzoTotale = ref(0);                
    const ivaTotale = ref(0);                   
    const costoTotale = ref(0);                 
    let posizioneIncolla = {sezione: 0, posizione: 0};
    const elencoScontiPreventivoStandard =  [
            {
                descrizione: 'Netto',
                aliquote: {0:0,1:0},
                fonte: 'Listino'
            },
            {
                descrizione: 'Ricarico normale',
                aliquote: {0:0.3,1:0},
                fonte: 'Costo'
            },
            {
                descrizione: 'Viessmann',
                aliquote:{0:-0.15,1:0},
                fonte: 'Listino'
            },
            {
                descrizione: 'Ricarico fotovoltaico',
                aliquote:{0:0.4,1:0},
                fonte: 'Costo'
            }
        ];

    // FIX: Watcher di sicurezza per cambi asincroni
    watch(() => props.idPreventivo, (nuovoId) => {
        idPreventivoSelezionato.value = nuovoId || -1;
        setupFormPreventivo();
    });

    // SETUP DEL COMPONENTE
    setupFormPreventivo();

    // FUNZIONI DEL COMPONENTE
    function setupFormPreventivo(effettuaReset=true) {
        for (const sc in elencoScontiPreventivoStandard) {
            aggiungiInfoDB(elencoScontiPreventivoStandard[sc],{id:sc});
        }
        
        if (!statoInterfaccia.value.formPreventivoTab || (props.idPreventivo==-1) ) {
            statoInterfaccia.value.formPreventivoTab = 1;
        }

        const id = idPreventivoSelezionato.value;

        // FIX: Scheletro di Base protettivo
        const scheletroBase = {
            numero: null,
            data: null,
            oggetto: null,
            importo: null,
            inviato: false,
            attivo: false,
            iva: null,
            validita: "30 gg",
            pagamento: "30% all'ordine, saldo al collaudo",
            riferimento: null,
            sconti: {},
            voci: {}
        };

        preventivoSelezionato.value = {};
        elencoVociPreventivo.value = [];
        elencoVociPreventivo.value.push([]);
        elencoScontiPreventivo.value = [];

        if ( id == -1 && preventivoDaAggiornare.value == null ) {
            // Nuovo preventivo
            preventivoSelezionato.value = { ...scheletroBase };
            // FIX: Ora usa correttamente preventivoSelezionato.value
            aggiungiInfoDB(preventivoSelezionato.value, {
                id: -1,
                idCliente: props.idCliente,
                idLead: props.idLead,
            });

            elencoScontiPreventivo.value = elencoScontiPreventivoStandard;

            elencoVociPreventivo.value[0] = [{
                codice: '1',
                tipo: 'Titolo',
                titolo: 'Titolo',
                ordine: 0
            }];
            aggiungiInfoDB(elencoVociPreventivo.value[0][0],{id:0});

        } else {
            // FIX: Estrazione Sicura
            const clienteOriginale = dbClienti.value[props.idCliente];
            const leadOriginale = (clienteOriginale && clienteOriginale.leads) ? clienteOriginale.leads[props.idLead] : null;
            const preventivoOriginale = (leadOriginale && leadOriginale.preventivi) ? leadOriginale.preventivi[id] : null;

            if (preventivoOriginale) {
                preventivoSelezionato.value = { ...scheletroBase, ...clonaOggetto(preventivoOriginale) };
                
                // FIX: Ricostruisce il DNA
                const infoRaw = leggiInfoDBRaw(preventivoOriginale) || { id: id, idCliente: props.idCliente, idLead: props.idLead };
                aggiungiInfoDB(preventivoSelezionato.value, infoRaw);
            } else {
                // Fallback
                preventivoSelezionato.value = { ...scheletroBase };
                aggiungiInfoDB(preventivoSelezionato.value, { id: id, idCliente: props.idCliente, idLead: props.idLead });
            }
        }

        if (preventivoSelezionato.value.sconti && Object.keys(preventivoSelezionato.value.sconti).length > 0) {
            for (const sc in preventivoSelezionato.value.sconti) {
                elencoScontiPreventivo.value.push(clonaOggetto(preventivoSelezionato.value.sconti[sc]));
                aggiungiInfoDB(elencoScontiPreventivo.value[elencoScontiPreventivo.value.length - 1],{
                    id: sc
                });
            }
        } else {
            elencoScontiPreventivo.value = elencoScontiPreventivoStandard;
            preventivoSelezionato.value.sconti = {};
            for (const sc in elencoScontiPreventivo.value) {
                preventivoSelezionato.value.sconti[leggiInfoDBRaw(elencoScontiPreventivo.value[sc]).id] = clonaOggetto(elencoScontiPreventivo.value[sc]);
            }
        }

        if (preventivoSelezionato.value.voci && Object.keys(preventivoSelezionato.value.voci).length > 0) {
            elencoVociPreventivo.value = creaVettoreVociPreventivo(preventivoSelezionato.value.voci);
        } else {
            elencoVociPreventivo.value[0] = [{
                codice: '1',
                tipo: 'Titolo',
                titolo: 'Titolo',
                ordine: 0
            }];
        }
        elencoVociPreventivo.value = inizializzaElencoVociPreventivo(elencoVociPreventivo.value);
        calcolaTotali();

        if (elencoVociPreventivo.value.length > props.sezioneVocePreventivo) {
            numSezioneVoceSelezionata.value = props.sezioneVocePreventivo;
        }
        preventivoDaAggiornare.value = null;
        if (effettuaReset) {
            resetForm();
        }
    }

    function preventivoModifica(valore, etichetta) {
        if (preventivoDaAggiornare.value == null) {
            inizializzaPreventivoDaAggiornare();
            caricaScontiDaAggiornare();
        }
        preventivoSelezionato.value[etichetta] = valore;
        preventivoDaAggiornare.value[etichetta] = valore;
    }

    function bChiudi() {
        if (preventivoDaAggiornare.value != null) {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:null,
                testoDanger:{testo:'Chiudi senza salvare le modifiche', comando:'chiudi'},
                messaggio:"Proseguendo perderai le modifiche fatte"
            };
        } else {
            emit('elementoSelezionato', {
                tipo: 'preventivo',
                idCliente: null,
                idLead: null,
                idPreventivo: null
            });
        }
    }

    function bAnnulla() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:null,
            testoDanger:{testo:'Cancella le modifiche', comando:'cancella'},
            messaggio:"Proseguendo perderai le modifiche fatte"
        };
    }

    function bSalva() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:{testo:'Salva', comando:'salva'},
            testoDanger:null,
            messaggio:"Vuoi salvare le modifiche al preventivo?"
        };
    }

    function bElimina() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:null,
            testoDanger:{testo:'Elimina', comando:'elimina'},
            messaggio:"Vuoi eliminare il preventivo?"
        };
    }

    async function bComandoModale(comando) {
        // FIX: Riferimenti sicuri 
        const tpIdCliente = leggiInfoDBRaw(preventivoSelezionato.value)?.idCliente || props.idCliente;
        const tpIdLead = leggiInfoDBRaw(preventivoSelezionato.value)?.idLead || props.idLead;

        // FIX: Scope isolati ({ }) per placare ESLint
        switch (comando) {
            case 'annulla': {
                messaggioModale.value = null;
                break;
            }
            case 'cancella': {
                emit('modificaElementoInCorso', false);
                messaggioModale.value = null;
                preventivoDaAggiornare.value = null;
                setupFormPreventivo();
                resetForm();
                break;
            }
            case 'chiudi': {
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'preventivo',
                    idCliente: null,
                    idLead: null,
                    idPreventivo: null
                });
                messaggioModale.value = null;
                break;
            }
            case 'salva': {
                if (idPreventivoSelezionato.value == -1) {
                    idPreventivoSelezionato.value = generaIdPreventivo(tpIdCliente, tpIdLead);
                }
                aggiungiInfoDB(preventivoDaAggiornare.value,{
                    id: idPreventivoSelezionato.value,
                    idCliente: tpIdCliente,
                    idLead: tpIdLead
                });
                formAttivo.value = false;
                await salvaPreventivoInFirestore(preventivoDaAggiornare.value);
                formAttivo.value = true;
                messaggioModale.value = null;
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'preventivo',
                    idCliente: tpIdCliente,
                    idLead: tpIdLead,
                    idPreventivo: idPreventivoSelezionato.value,
                    sezioneVocePreventivo: numSezioneVoceSelezionata.value
                });
                break;
            }
            case 'elimina': {
                if (statoInterfaccia.value.ultimoPreventivo && statoInterfaccia.value.ultimoPreventivo.idPreventivo === idPreventivoSelezionato.value) {
                    statoInterfaccia.value.ultimoPreventivo = null;
                }
                eliminaPreventivoInFirestore(tpIdCliente, tpIdLead, idPreventivoSelezionato.value);
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'lead',
                    idCliente: tpIdCliente,
                    idLead: tpIdLead
                });
                break;
            }
            case 'incolla': {
                incollaVoci(posizioneIncolla.sezione, posizioneIncolla.posizione);
                break;
            }
        }
    }

    function gestisciSelezioneElemento(elSelezionato) {
        if (preventivoDaAggiornare.value != null) {
            messaggioModale.value = {
                testoLight:{testo:'Ok', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Prima di uscire devi salvare o annullare le modifiche."
            };
        } else {
            emit('elementoSelezionato', elSelezionato);
        }
    }

    async function resetForm() {
        formAttivo.value = false;
        await nextTick();
        formAttivo.value = true;
    }

    function salvaRiferimentoComputo() {
        if (idPreventivoSelezionato.value !== -1 && props.idCliente && props.idLead) {
            statoInterfaccia.value.ultimoPreventivo = {
                idCliente: props.idCliente,
                idLead: props.idLead,
                idPreventivo: idPreventivoSelezionato.value,
                sezioneVocePreventivo: numSezioneVoceSelezionata.value
            };
        }
    }

    onBeforeUnmount(() => {
        if (statoInterfaccia.value.formPreventivoTab === 2) {
            salvaRiferimentoComputo();
        }
    });

    function bSelezionaTAb(index) {
        if (statoInterfaccia.value.formPreventivoTab === 2 && index !== 2) {
            salvaRiferimentoComputo();
        }
        statoInterfaccia.value.formPreventivoTab = index;
    }

    function generaPrezzoUnitario(vocePrev) {
        let tempPr;
        if (vocePrev.scVisibile) {
            if (vocePrev.prListinoVen)
                tempPr = vocePrev.prListinoVen;
            else {
                tempPr = vocePrev.prListino;
            }
        } else {
            tempPr = prezzoVocePreventivo(vocePrev, preventivoSelezionato.value.sconti[vocePrev.tipoRicaricoSconto]);
        }
        return tempPr;
    }

    function vocePreventivoModifica(azione, voceModificata) {
        if (azione!='annulla') {
            if (preventivoDaAggiornare.value == null) {
                inizializzaPreventivoDaAggiornare();
            }
            if (!preventivoDaAggiornare.value.voci) {
                caricaVociDaAggiornare();
            }
            if (!preventivoDaAggiornare.value.sconti) {
                caricaScontiDaAggiornare();
            }
            let tempElencoVociPreventivo;
            let tempOrdine;

            switch (azione) {
                case 'modifica':
                    elencoVociPreventivo.value[numSezioneVoceSelezionata.value][numVoceSelezionata.value] = voceModificata;
                    elencoVociPreventivo.value = inizializzaElencoVociPreventivo(elencoVociPreventivo.value);
                    break;

                case 'inserisci':
                    tempElencoVociPreventivo = [];
                    tempElencoVociPreventivo.push([]);

                    tempOrdine = elencoVociPreventivo.value[numSezioneVoceSelezionata.value][numVoceSelezionata.value].ordine;
                    tempOrdine++;
                    for (const sezVc in elencoVociPreventivo.value) {
                        for (const vc in elencoVociPreventivo.value[sezVc]) {
                            if ( elencoVociPreventivo.value[sezVc][vc].tipo=='Articolo' ||
                                elencoVociPreventivo.value[sezVc][vc].tipo=='Nota' ||
                                elencoVociPreventivo.value[sezVc][vc].tipo=='Titolo' ) {
                                tempElencoVociPreventivo[0].push(clonaOggetto(elencoVociPreventivo.value[sezVc][vc]));
                            }
                        }
                    }
                    tempElencoVociPreventivo[0].splice(tempOrdine, 0, voceModificata);
                    for (const vc in tempElencoVociPreventivo[0]) {
                        tempElencoVociPreventivo[0][vc].ordine = Number(vc);
                    }
                    elencoVociPreventivo.value = inizializzaElencoVociPreventivo(tempElencoVociPreventivo);
                    break;
            }
            caricaVociDaAggiornare();
            calcolaTotali();
        }
        numVoceSelezionata.value = null;
        resetForm();
    }

    async function scontoPreventivoModifica(azione, idScontoModificato, etichetta, valore) {
        let nuovoSconto = null;
        let tempId = null;
        if (azione!='annulla' && azione!='elimina') {
            if (preventivoDaAggiornare.value == null) {
                preventivoDaAggiornare.value = {};
                emit('modificaElementoInCorso', true);
                if (!preventivoDaAggiornare.value.sconti) {
                    preventivoDaAggiornare.value.sconti = {};
                    for (const sc in elencoScontiPreventivo.value) {
                        preventivoDaAggiornare.value.sconti[sc] = clonaOggetto(elencoScontiPreventivo.value[sc]);
                    }
                }
            }
            if (!preventivoDaAggiornare.value.voci) {
                caricaVociDaAggiornare();
            }
        }
        switch (azione) {
            case 'annulla':
                break;
            case 'modifica':
                if (preventivoDaAggiornare.value == null) {
                    preventivoDaAggiornare.value = {};
                    emit('modificaElementoInCorso', true);
                }
                if (!preventivoDaAggiornare.value.sconti) {
                    preventivoDaAggiornare.value.sconti = {};
                    for (const sc in preventivoSelezionato.value.sconti) {
                        preventivoDaAggiornare.value.sconti[sc] = preventivoSelezionato.value.sconti[sc];
                    }
                }
                for (const sc in elencoScontiPreventivo.value) {
                    if (leggiInfoDBRaw(elencoScontiPreventivo.value[sc])?.id == idScontoModificato) {
                        elencoScontiPreventivo.value[sc][etichetta] = valore;
                        preventivoDaAggiornare.value.sconti[idScontoModificato][etichetta] = valore;
                        preventivoSelezionato.value.sconti[idScontoModificato][etichetta] = valore;
                        break;
                    }
                }
                calcolaTotali();
                break;
            case 'elimina':
                await eliminaScontoDaPreventivoInFirestore(props.idCliente, props.idLead, props.idPreventivo, idScontoModificato);
                setupFormPreventivo();
                break;
            case 'aggiungi':
                tempId = 1;
                for (const sc in elencoScontiPreventivo.value) {
                    if (leggiInfoDBRaw(elencoScontiPreventivo.value[sc])?.id >= tempId) {
                        tempId = leggiInfoDBRaw(elencoScontiPreventivo.value[sc]).id;
                        tempId = parseInt(tempId) + 1;
                    }
                }
                nuovoSconto = {
                    descrizione: '',
                    aliquote: {0:0,1:0},
                    fonte: 'Costo'
                };
                elencoScontiPreventivo.value.push(nuovoSconto);
                aggiungiInfoDB(elencoScontiPreventivo.value[elencoScontiPreventivo.value.length - 1],{
                    id: tempId
                });
                if (preventivoDaAggiornare.value == null) {
                    preventivoDaAggiornare.value = {};
                    emit('modificaElementoInCorso', true);
                }
                if (!preventivoDaAggiornare.value.sconti) {
                    preventivoDaAggiornare.value.sconti = {};
                    for (const sc in preventivoSelezionato.value.sconti) {
                        preventivoDaAggiornare.value.sconti[sc] = preventivoSelezionato.value.sconti[sc];
                    }
                }
                preventivoDaAggiornare.value.sconti[tempId] = clonaOggetto(nuovoSconto);
                preventivoSelezionato.value.sconti[tempId] = clonaOggetto(nuovoSconto);
        }
        resetForm();
    }
    
    function bSpostaVocePreventivo(sezione, indice, spostamento, interaSezione){
        if (!spostamento || spostamento>=0) {
            spostamento = 1;
        } else {
            spostamento = -1;
        }

        if (interaSezione==true){
            if (spostamento>0) {
                numSezioneVoceSelezionata.value++;
            } else {
                numSezioneVoceSelezionata.value--;
            }
        }

        let tempElencoVociPreventivo = [];
        tempElencoVociPreventivo.push([]);
        let tempIndice = 0;
        for (const sezVc in elencoVociPreventivo.value) {
            for (const vc in elencoVociPreventivo.value[sezVc]) {
                if ( elencoVociPreventivo.value[sezVc][vc].tipo=='Titolo' ||
                    elencoVociPreventivo.value[sezVc][vc].tipo=='Articolo' ||
                    elencoVociPreventivo.value[sezVc][vc].tipo=='Nota' ) {
                    if ( sezVc == sezione && vc == indice ) {
                        tempIndice = tempElencoVociPreventivo[0].length;
                    }
                    tempElencoVociPreventivo[0].push(clonaOggetto(elencoVociPreventivo.value[sezVc][vc]));
                }
            }
        }
        let rimossi = [];
        let nuovoTempIndice = 0;
        if (interaSezione == false) {
            rimossi = tempElencoVociPreventivo[0].splice(tempIndice, 1);
            nuovoTempIndice = tempIndice + spostamento;
        } else {
            let lunghezzaSezione = 1;
            while (tempElencoVociPreventivo[0][tempIndice+lunghezzaSezione] && tempElencoVociPreventivo[0][tempIndice+lunghezzaSezione].tipo!='Titolo') {
                lunghezzaSezione++;
            }
            rimossi = tempElencoVociPreventivo[0].splice(tempIndice, lunghezzaSezione);
            if (spostamento>0) {
                nuovoTempIndice = tempIndice+1;
                while (nuovoTempIndice<tempElencoVociPreventivo[0].length && tempElencoVociPreventivo[0][nuovoTempIndice].tipo!='Titolo') {
                    nuovoTempIndice++;
                }
            } else {
                nuovoTempIndice = tempIndice-1;
                while (nuovoTempIndice>0 && tempElencoVociPreventivo[0][nuovoTempIndice].tipo!='Titolo') {
                    nuovoTempIndice--;
                }
            }
        }

        if (nuovoTempIndice < 0) nuovoTempIndice = 0;
        if (nuovoTempIndice > tempElencoVociPreventivo[0].length) nuovoTempIndice = tempElencoVociPreventivo[0].length;
        tempElencoVociPreventivo[0].splice(nuovoTempIndice, 0, ...rimossi);
        for (const vc in tempElencoVociPreventivo[0]) {
            tempElencoVociPreventivo[0][vc].ordine = Number(vc);
        }

        elencoVociPreventivo.value = inizializzaElencoVociPreventivo(tempElencoVociPreventivo);
        if (preventivoDaAggiornare.value == null) {
            inizializzaPreventivoDaAggiornare();
        }
        caricaVociDaAggiornare();
        calcolaTotali();
        resetForm();
    }

    function bEliminaVocePreventivo(sezione, indice) {
        if (preventivoDaAggiornare.value == null) {
            preventivoDaAggiornare.value = {};
            emit('modificaElementoInCorso', true);
        }
        elencoVociPreventivo.value[sezione].splice(indice, 1);
        elencoVociPreventivo.value = inizializzaElencoVociPreventivo(elencoVociPreventivo.value);
        if (preventivoDaAggiornare.value == null) {
            inizializzaPreventivoDaAggiornare();
        }
        caricaVociDaAggiornare();
        calcolaTotali();
        if (numSezioneVoceSelezionata.value == elencoVociPreventivo.value.length) {
            numSezioneVoceSelezionata.value--;
        }

        resetForm();
    }

    function calcolaTotali() {
        prezzoTotale.value = 0;
        costoTotale.value = 0;
        ivaTotale.value = 0;
        beniSignificativi.value = [];
        for (const sezione in elencoVociPreventivo.value) {
            let tempPrezzo = 0;
            let tempCosto = 0;
            beniSignificativi.value[sezione] = 0;
            let tempIva = 0;
            for (const vc in elencoVociPreventivo.value[sezione]) {
                if (elencoVociPreventivo.value[sezione][vc].tipo == 'Articolo') {
                    tempPrezzo += prezzoVocePreventivo(elencoVociPreventivo.value[sezione][vc], preventivoSelezionato.value.sconti[elencoVociPreventivo.value[sezione][vc].tipoRicaricoSconto])*elencoVociPreventivo.value[sezione][vc].quantita;
                    tempCosto += costoVocePreventivo(elencoVociPreventivo.value[sezione][vc], preventivoSelezionato.value.sconti[elencoVociPreventivo.value[sezione][vc].tipoRicaricoSconto])*elencoVociPreventivo.value[sezione][vc].quantita;
                    if (elencoVociPreventivo.value[sezione][vc].beneSignificativo == 'Prezzo') {
                        beniSignificativi.value[sezione] += prezzoVocePreventivo(elencoVociPreventivo.value[sezione][vc], preventivoSelezionato.value.sconti[elencoVociPreventivo.value[sezione][vc].tipoRicaricoSconto])*elencoVociPreventivo.value[sezione][vc].quantita;
                    } else if (elencoVociPreventivo.value[sezione][vc].beneSignificativo == 'Costo') {
                        beniSignificativi.value[sezione] += costoVocePreventivo(elencoVociPreventivo.value[sezione][vc], preventivoSelezionato.value.sconti[elencoVociPreventivo.value[sezione][vc].tipoRicaricoSconto])*elencoVociPreventivo.value[sezione][vc].quantita;
                    }
                } else if (elencoVociPreventivo.value[sezione][vc].tipo == 'Totale') {
                    elencoVociPreventivo.value[sezione][vc].importo = tempPrezzo;
                    elencoVociPreventivo.value[sezione][vc].costo = tempCosto;
                }
                if (elencoVociPreventivo.value[sezione][vc].tipo == 'Iva') {
                    switch (preventivoSelezionato.value.iva) {
                        case 'Ordinaria 22%':
                            elencoVociPreventivo.value[sezione][vc].importo = tempPrezzo*0.22;
                            break;
                        case 'Manutenzione straord. 10%':
                            elencoVociPreventivo.value[sezione][vc].importo = tempPrezzo*0.1;
                            break;
                        case 'Iva ridotta 4%':
                            elencoVociPreventivo.value[sezione][vc].importo = tempPrezzo*0.04;
                            break;
                        case 'Manutenzione straord. 10%-22%':
                            if ((tempPrezzo-beniSignificativi.value[sezione]) >= 0.5*tempPrezzo-0.01) {
                                elencoVociPreventivo.value[sezione][vc].importo = tempPrezzo*0.1;
                            } else {
                                elencoVociPreventivo.value[sezione][vc].importo = 2*(tempPrezzo-beniSignificativi.value[sezione])*0.1;
                                elencoVociPreventivo.value[sezione][vc].importo += (tempPrezzo-2*(tempPrezzo-beniSignificativi.value[sezione]))*0.22;
                            }
                            break;
                    }
                    tempIva += elencoVociPreventivo.value[sezione][vc].importo;
                    ivaTotale.value += tempIva;

                }
                if (elencoVociPreventivo.value[sezione][vc].tipo == 'TotaleIC') {
                    elencoVociPreventivo.value[sezione][vc].importo = tempPrezzo + tempIva;
                }
            }
            prezzoTotale.value += tempPrezzo;
            costoTotale.value += tempCosto;
        }
    }

    function voceRicaricoScontoEliminabile(idRicaricoSconto) {
        for (const sezione of elencoVociPreventivo.value){
            for (const voce of sezione) {
                if (voce.tipoRicaricoSconto && voce.tipoRicaricoSconto === idRicaricoSconto) {
                    return false; 
                }
            }
        }
        return true; 
    }

    function testoSconti(vocePreventivo, sempreVisibile) {
        let tempTesto = '';
        if (vocePreventivo.scVisibile || sempreVisibile) {
            if (preventivoSelezionato.value.sconti[vocePreventivo.tipoRicaricoSconto].aliquote[0]) {
                tempTesto += (-100*preventivoSelezionato.value.sconti[vocePreventivo.tipoRicaricoSconto].aliquote[0]);
                tempTesto += '%';
            }
            if (preventivoSelezionato.value.sconti[vocePreventivo.tipoRicaricoSconto].aliquote[1]) {
                tempTesto += '+';
                tempTesto += (-100*preventivoSelezionato.value.sconti[vocePreventivo.tipoRicaricoSconto].aliquote[1]);
                tempTesto += '%';
            }
        }
        return tempTesto;
    }

    function generaTestoMultiriga(testo) {
        if (testo) {
            return testo.replace(/\r\n?/g, '\n').replace(/\n/g, '<br>');
        } else {
            return '';
        }
    }

    function bCopia( sezione, voce ) {
        copiaTrasporto.value.vociPreventivo = [];
        if (sezione==-1) {
            for (const sz in elencoVociPreventivo.value) {
                for (const vc in elencoVociPreventivo.value[sz]) {
                    if ( elencoVociPreventivo.value[sz][vc].tipo=='Titolo' ||
                        elencoVociPreventivo.value[sz][vc].tipo=='Articolo' ||
                        elencoVociPreventivo.value[sz][vc].tipo=='Nota' ) {
                        copiaTrasporto.value.vociPreventivo.push(clonaOggetto(elencoVociPreventivo.value[sz][vc]));
                    }
                }
            }
        } else if (voce==-1) {
            for (const vc in elencoVociPreventivo.value[sezione]) {
                if ( elencoVociPreventivo.value[sezione][vc].tipo=='Titolo' ||
                    elencoVociPreventivo.value[sezione][vc].tipo=='Articolo' ||
                    elencoVociPreventivo.value[sezione][vc].tipo=='Nota' ) {
                    copiaTrasporto.value.vociPreventivo.push(clonaOggetto(elencoVociPreventivo.value[sezione][vc]));
                }
            }
        } else {
            if (elencoVociPreventivo.value[sezione][voce].tipo!='Totale') {
                copiaTrasporto.value.vociPreventivo.push(clonaOggetto(elencoVociPreventivo.value[sezione][voce]));
            }
        }

        copiaTrasporto.value.scontiVociPreventivo = [];
        for (const sc in elencoScontiPreventivo.value) {
            copiaTrasporto.value.scontiVociPreventivo.push(clonaOggetto(elencoScontiPreventivo.value[sc]));
        }

        if (copiaTrasporto.value.vociPreventivo.length>1) {
            messaggioModale.value = {
                testoLight:{testo:'Ok', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Hai salvato negli appunti " + copiaTrasporto.value.vociPreventivo.length + " voci."
            }
        }
    }

    function bIncolla( sez, pos ) {
        posizioneIncolla.sezione = sez;
        posizioneIncolla.posizione = pos;
        if (copiaTrasporto.value.vociPreventivo.length>1) {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:{testo:'Incolla', comando:'incolla'},
                testoDanger:null,
                messaggio:"Vuoi incollare " + copiaTrasporto.value.vociPreventivo.length + " voci?"
            };
        } else {
            incollaVoci( sez, pos );
        }
    }

    function incollaVoci( sez, pos ) {
        if (preventivoDaAggiornare.value == null) {
            inizializzaPreventivoDaAggiornare();
        }
        if (!preventivoDaAggiornare.value.voci) {
            caricaVociDaAggiornare();
        }
        if (!preventivoDaAggiornare.value.sconti) {
            caricaScontiDaAggiornare();
        }
        let tempElencoVociPreventivo;
        let tempOrdine = 0;

        tempElencoVociPreventivo = [];
        tempElencoVociPreventivo.push([]);  

        if (sez!=null && pos!=null) {
            tempOrdine = elencoVociPreventivo.value[sez][pos].ordine;
        } else {
            for (const sezVc in elencoVociPreventivo.value) {
                for (const vc in elencoVociPreventivo.value[sezVc]) {
                    if ( elencoVociPreventivo.value[sezVc][vc].tipo=='Articolo'
                        || elencoVociPreventivo.value[sezVc][vc].tipo=='Titolo'
                        || elencoVociPreventivo.value[sezVc][vc].tipo=='Nota' ) {
                        if (tempOrdine<elencoVociPreventivo.value[sezVc][vc].ordine){
                            tempOrdine = elencoVociPreventivo.value[sezVc][vc].ordine;
                        }
                    }
                }
            }
        }
        tempOrdine++;   

        for (const sezVc in elencoVociPreventivo.value) {
            for (const vc in elencoVociPreventivo.value[sezVc]) {
                if ( elencoVociPreventivo.value[sezVc][vc].tipo=='Articolo'
                    || elencoVociPreventivo.value[sezVc][vc].tipo=='Titolo'
                    || elencoVociPreventivo.value[sezVc][vc].tipo=='Nota' ) {
                    tempElencoVociPreventivo[0].push(clonaOggetto(elencoVociPreventivo.value[sezVc][vc]));
                }
            }
        }

        tempElencoVociPreventivo[0].splice(tempOrdine, 0, ...copiaTrasporto.value.vociPreventivo);
        
        for (const vc in tempElencoVociPreventivo[0]) {
            tempElencoVociPreventivo[0][vc].ordine = Number(vc);
        }

        let tempRicaricoSconto = 0;     
        for (const vc in copiaTrasporto.value.vociPreventivo) {
            if (copiaTrasporto.value.vociPreventivo[vc].tipoRicaricoSconto) {
                if (copiaTrasporto.value.vociPreventivo[vc].tipoRicaricoSconto>tempRicaricoSconto) {
                    tempRicaricoSconto = copiaTrasporto.value.vociPreventivo[vc].tipoRicaricoSconto;
                }
            }
        }
        let scontiAggiunti = false;
        if (tempRicaricoSconto>(elencoScontiPreventivo.value.length-1)) {
            for ( let i=(elencoScontiPreventivo.value.length); i<=tempRicaricoSconto; i++ ) {
                elencoScontiPreventivo.value.push(copiaTrasporto.value.scontiVociPreventivo[i]);
                aggiungiInfoDB(elencoScontiPreventivo.value[i],{
                    id: i
                });
                preventivoDaAggiornare.value.sconti[i] = elencoScontiPreventivo.value[i];
                preventivoSelezionato.value.sconti[i] = elencoScontiPreventivo.value[i];

            }
            scontiAggiunti = true;
        }

        elencoVociPreventivo.value = inizializzaElencoVociPreventivo(tempElencoVociPreventivo);
        caricaVociDaAggiornare();
        if (scontiAggiunti) caricaScontiDaAggiornare();
        calcolaTotali();
        if (scontiAggiunti) {
            messaggioModale.value = {
                testoLight:{testo:'Ok', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Sono stati aggiunti degli sconti. Verifica con attenzione."
            }
        } else if (copiaTrasporto.value.vociPreventivo.length>1) {
            messaggioModale.value = {
                testoLight:{testo:'Ok', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Sono state aggiunte " + copiaTrasporto.value.vociPreventivo.length + " voci. Verifica gli sconti."
            }
        }
    }

    function creaVettoreVociPreventivo(oggettoVc) {
        let vettoreVc = [];
        vettoreVc.push([]);
        for (let vc in oggettoVc) {
            vettoreVc[0].push(clonaOggetto(oggettoVc[vc]));
        }
        return vettoreVc;
    }

    function inizializzaElencoVociPreventivo(elencoVc) {
        let elencoVcSemplice = [];      
        for (const sezione in elencoVc) {
            for (const vc in elencoVc[sezione]) {
                const tempTipo = elencoVc[sezione][vc].tipo;
                if (tempTipo=='Articolo' || tempTipo=='Titolo' || tempTipo=='Nota') {
                    elencoVcSemplice.push(clonaOggetto(elencoVc[sezione][vc]));
                }
            }
        }
        elencoVcSemplice.sort( (a, b) => {
            let val = a.ordine - b.ordine;
            return (val);
        });
        let tempElencoVc = [];
        let numSezione = 0;
        let numVoce = 0;
        tempElencoVc.push([]);
        for (let vc in elencoVcSemplice){
            if (elencoVcSemplice[vc].tipo == 'Titolo'){
                if (!(numSezione==0 && numVoce==0)) {
                    aggiungiTotaliSezione(numSezione, tempElencoVc);
                }
                if (numVoce > 0) {
                    tempElencoVc.push([]);
                    numSezione++;
                }
                numVoce = 0;
            }
            let tempVoce;
            tempVoce = elencoVcSemplice[vc];
            tempVoce.ordine = Number(vc);
            aggiungiInfoDB(tempVoce,{
                id: vc
            });
            tempElencoVc[numSezione].push(tempVoce);
            numVoce++;
        }
        aggiungiTotaliSezione(numSezione, tempElencoVc);

        return tempElencoVc;
    }

    function aggiungiTotaliSezione(sez, elencoVoci) {
        elencoVoci[sez].push({
            tipo: 'Totale',
            descrizione: 'TOTALE SEZIONE',
            importo: 0,
            costo: 0
        });
        if (preventivoSelezionato.value.iva) {
            const tempTipoIva = preventivoSelezionato.value.iva;
            if (tempTipoIva=='Ordinaria 22%'
                || tempTipoIva=='Manutenzione straord. 10%'
                || tempTipoIva=='Ristrutturazione 10%'
                || tempTipoIva=='Iva ridotta 4%'
                || tempTipoIva=='Manutenzione straord. 10%-22%'){
                elencoVoci[sez].push({
                    tipo: 'Iva',
                    descrizione: 'IVA: ' + preventivoSelezionato.value.iva,
                    importo: 0
                });
                elencoVoci[sez].push({
                    tipo: 'TotaleIC',
                    descrizione: 'TOTALE IVA COMPRESA',
                    importo: 0
                });
            }

        }        
    }

    function caricaVociDaAggiornare() {
        preventivoDaAggiornare.value.voci = {};
        for (const sezione in elencoVociPreventivo.value) {
            for (const vc in elencoVociPreventivo.value[sezione]) {
                const tempTipo = elencoVociPreventivo.value[sezione][vc].tipo;
                if (tempTipo=='Titolo' || tempTipo=='Articolo' || tempTipo=='Nota') {
                    preventivoDaAggiornare.value.voci[leggiInfoDBRaw(elencoVociPreventivo.value[sezione][vc]).id] = clonaOggetto(elencoVociPreventivo.value[sezione][vc]);
                }
            }
        }
    }

    function caricaScontiDaAggiornare() {
        preventivoDaAggiornare.value.sconti = {};
        for (const sc in elencoScontiPreventivo.value) {
            preventivoDaAggiornare.value.sconti[leggiInfoDBRaw(elencoScontiPreventivo.value[sc]).id] = clonaOggetto(elencoScontiPreventivo.value[sc]);
        }
    }

    function inizializzaPreventivoDaAggiornare() {
        preventivoDaAggiornare.value = {};
        if (props.idPreventivo==-1) {
            preventivoDaAggiornare.value = clonaOggetto(preventivoSelezionato.value);
            aggiungiInfoDB(preventivoDaAggiornare.value,
                leggiInfoDBRaw(preventivoSelezionato.value)
            );
        }
        emit('modificaElementoInCorso', true);
    }

    function bCambiaSezione(step){
        numSezioneVoceSelezionata.value += step;
        if (numSezioneVoceSelezionata.value < 0) {
            numSezioneVoceSelezionata.value = 0;
        } else if (numSezioneVoceSelezionata.value >= elencoVociPreventivo.value.length) {
            numSezioneVoceSelezionata.value = elencoVociPreventivo.value.length - 1;
        }
    }

	function scaricaXlsxPreventivo() {
        let nomeFile = 'P-';
        if (preventivoSelezionato.value.data) {
            nomeFile += dataDaTimestamp(preventivoSelezionato.value.data, 'anno');
        } else {
            const d = new Date();
            nomeFile += d.getFullYear();
        }
        nomeFile += '-';
        if (preventivoSelezionato.value.numero) {
            nomeFile += padNumero(preventivoSelezionato.value.numero,3);
        } else {
            nomeFile += 'XXX';
        }
        nomeFile += ' -';
        if (dbClienti.value[props.idCliente]) {
            if (dbClienti.value[props.idCliente].nome) {
                nomeFile += ' ' + dbClienti.value[props.idCliente].nome;
            }
            if (dbClienti.value[props.idCliente].cognome) {
                nomeFile += ' ' + dbClienti.value[props.idCliente].cognome;
            }
        }
        if (preventivoSelezionato.value.oggetto) {
            nomeFile += ' - ' + preventivoSelezionato.value.oggetto;
        }
        nomeFile += ' - ';
        if (preventivoSelezionato.value.data) {
            nomeFile += dataDaTimestamp(preventivoSelezionato.value.data, 'testoAAAA-MM-GG');
        } else {
            const d = new Date();
            nomeFile += d.getFullYear() + '-' + padNumero((d.getMonth() + 1), 2) + '-' + padNumero(d.getDate(), 2);
        }
		nomeFile += '.xlsx';

		// 1) Intestazione 
		let headerData = [
			["", "", ""],
			["", "", ""],
			["", "", ""],
			["", "", ""],
			["", "", ""],
			["", "", ""],
			["", "", ""],
			["Preventivo n.", ( preventivoSelezionato.value.data?dataDaTimestamp(preventivoSelezionato.value.data, 'anno'):"______" ) + '/' + ( preventivoSelezionato.value.numero?padNumero(preventivoSelezionato.value.numero, 3):"____" ), ""],
			["Data", dataDaTimestamp(preventivoSelezionato.value.data, 'testo'), ""],
			["Validità", preventivoSelezionato.value.validita?preventivoSelezionato.value.validita:"", ""],
			["Pagamento", preventivoSelezionato.value.pagamento?preventivoSelezionato.value.pagamento:"", ""],
			[preventivoSelezionato.value.riferimento?"Riferimento":"", preventivoSelezionato.value.riferimento?preventivoSelezionato.value.riferimento:"", ""]
		];
        for (let i = 0; i < 38; i++) {
            headerData.push(["", "", ""])
        }

		// 2) Prepara dati per fogli
		const bodyHeader = ["Codice", "Descrizione", "Unità", "Quantità", "Prezzo", "Sconto", "Totale"];
		const sheetsData = {};

		(elencoVociPreventivo.value || []).forEach((sezione, idxSez) => {
			const rows = [];
			const vt = Array.isArray(sezione) ? sezione.find(v => v && v.tipo === 'Titolo') : null;
			const codiceTitolo = vt && vt.codice ? vt.codice : "";
			const titoloUp = vt && vt.titolo ? String(vt.titolo).toUpperCase() : "";
			const sottotitolo = vt && vt.sottotitolo ? vt.sottotitolo : "";
			rows.push([codiceTitolo, titoloUp]);
			rows.push(["", sottotitolo]);
			rows.push(["", "", "", "", "", "", ""]);
			rows.push(bodyHeader);
			(sezione || []).forEach(ev => {
				if (ev && ev.tipo === 'Articolo') {
					rows.push([
						ev.codice,
						ev.descrizione,
						ev.unita,
						ev.quantita,
						generaPrezzoUnitario(ev),
						testoSconti(ev, false),
						prezzoVocePreventivo(ev, preventivoSelezionato.value.sconti[ev.tipoRicaricoSconto]) * ev.quantita
					]);
				} else if (ev && ev.tipo === 'Nota') {
					rows.push([
						"",
						ev.descrizione
					]);
                }
			});
			sheetsData[idxSez + 1] = rows;
		});

		// 3) Inserisci riga vuota e TOTALE in ogni sheet
        let ultimaRigaVoci = [];
		Object.keys(sheetsData).forEach(si => {
			const data = sheetsData[si];
			const firstDataRow = 5; 
            const lastDataRow = data.length; 
            ultimaRigaVoci.push(lastDataRow);
			data.push(["", "", "", "", "", "", ""]);
            switch (preventivoSelezionato.value.iva) {
                case 'Ordinaria 22%':
                case 'Manutenzione straord. 10%':
                case 'Ristrutturazione 10%':
                    data.push([
                        "", "TOTALE", "", "", "", "",
                        { t: 'n', f: `SUM(G${firstDataRow}:G${lastDataRow})`, z: '#,##0.00' }
                    ]);
                    data.push([
                        "",
                        "IVA",
                        "",
                        { t: 'n', v: preventivoSelezionato.value.iva=='Ordinaria 22%' ? 0.22 : 0.1, z: '0%' },
                         "", "",
                        { t: 'n', f: `G${lastDataRow+2}*D${lastDataRow+3}`, z: '#,##0.00' }
                    ]);
                    data.push(["", "", "", "", "", "", ""]);
                    data.push([
                        "", "TOTALE IVA COMPRESA", "", "", "", "",
                        { t: 'n', f: `G${lastDataRow+2}+G${lastDataRow+3}`, z: '#,##0.00' }
                    ]);
                    break;
                case 'Manutenzione straord. 10%-22%':
                    data.push([
                        "", "TOTALE", "", "", "", "",
                        { t: 'n', f: `SUM(G${firstDataRow}:G${lastDataRow})`, z: '#,##0.00' }
                    ]);
                    data.push([
                        "",
                        "Beni significativi",
                        "", "", "", "",
                        { t: 'n', v: beniSignificativi.value[si-1], z: '#,##0.00' }
                    ]);
                    data.push([
                        "",
                        "IVA",
                        "",
                        { t: 'n', v: 0.10, z: '0%' },
                         "", "",
                        { t: 'n', f: `IF(G${lastDataRow+3}>G${lastDataRow+2}/2, 2*(G${lastDataRow+2}-G${lastDataRow+3})*D${lastDataRow+4}, G${lastDataRow+2}*D${lastDataRow+4})`, z: '#,##0.00' }
                    ]);
                    data.push([
                        "",
                        "IVA",
                        "",
                        { t: 'n', v: 0.22, z: '0%' },
                         "", "",
                        { t: 'n', f: `IF(G${lastDataRow+3}>G${lastDataRow+2}/2, (G${lastDataRow+2}-2*(G${lastDataRow+2}-G${lastDataRow+3}))*D${lastDataRow+5}, 0)`, z: '#,##0.00' }
                    ]);
                    data.push(["", "", "", "", "", "", ""]);
                    data.push([
                        "", "TOTALE IVA COMPRESA", "", "", "", "",
                        { t: 'n', f: `G${lastDataRow+2}+G${lastDataRow+4}+G${lastDataRow+5}`, z: '#,##0.00' }
                    ]);
                    break;
                default:
                    data.push([
                        "",
                        "TOTALE (iva esclusa)",
                        "", "", "", "",
                        { t: 'n', f: `SUM(G${firstDataRow}:G${lastDataRow})`, z: '#,##0.00' }
                    ]);
            }

		});

		const wb = XLSX.utils.book_new();

		const wsInt = XLSX.utils.aoa_to_sheet(headerData);
		wsInt["!cols"] = [{ width: 16 }, { width: 52 }, { width: 36 }];
		applicaFontDefault(wsInt, 10);
		wsInt['!merges'] = wsInt['!merges'] || [];
		wsInt['!merges'].push({ s: { r: 5, c: 0 }, e: { r: 5, c: 1 } });     
		wsInt['!merges'].push({ s: { r: 9, c: 1 }, e: { r: 9, c: 2 } });     
		wsInt['!merges'].push({ s: { r: 10, c: 1 }, e: { r: 10, c: 2 } });   
		const infoAzienda = "LMC srl\nSede legale: Via Gobetti 33, 10015 Ivrea, TO\nSede operativa: Via Ivrea 41, 10019 Strambino, TO\nTel. 0125 1925603\nP.I. 10650450017 - C.F. 10650450017\nwww.lmc-soluzioni.it";
		wsInt['A6'] = wsInt['A6'] || { t: 's', v: '' };
		wsInt['A6'].v = infoAzienda;
		aggiungiStileXls(wsInt['A6'], { font: { name: 'Arial', sz: 10 }, alignment: { wrapText: true, vertical: 'top' } });
		wsInt['C5'] = wsInt['C5'] || { t: 's', v: '' };
		wsInt['C5'].v = 'Intestatario';
		aggiungiStileXls(wsInt['C5'], { font: { name: 'Arial', sz: 10 }, border: { bottom: { style: 'thin', color: { rgb: 'FF000000' } } } });
		let intestazioneCliente = dbClienti.value[props.idCliente]?.nome ? ( dbClienti.value[props.idCliente].nome + ' ' ) : '' ;
        intestazioneCliente += dbClienti.value[props.idCliente]?.cognome + '\n';
        if ( dbClienti.value[props.idCliente]?.indirizzo ) {
            if ( dbClienti.value[props.idCliente].indirizzo.via ) {
                intestazioneCliente += dbClienti.value[props.idCliente].indirizzo.via;
                intestazioneCliente += dbClienti.value[props.idCliente].indirizzo.civico ? ( ' ' + dbClienti.value[props.idCliente].indirizzo.civico ) : '';
                intestazioneCliente += '\n';
            }
            if ( dbClienti.value[props.idCliente].indirizzo.citta ) {
                intestazioneCliente += dbClienti.value[props.idCliente].indirizzo.cap ? ( dbClienti.value[props.idCliente].indirizzo.cap + ' ') : '';
                intestazioneCliente += dbClienti.value[props.idCliente].indirizzo.citta;
                intestazioneCliente += dbClienti.value[props.idCliente].indirizzo.provincia ? (' (' + dbClienti.value[props.idCliente].indirizzo.provincia + ')') : '';
                intestazioneCliente += '\n';
            }
            if ( dbClienti.value[props.idCliente].indirizzo.stato || dbClienti.value[props.idCliente].indirizzo.stato == 'Italia') {
                intestazioneCliente += (dbClienti.value[props.idCliente].indirizzo.stato + '\n');
            }
        }
        intestazioneCliente += '\nCod. Cliente: '
        intestazioneCliente += (dbClienti.value[props.idCliente] && (dbClienti.value[props.idCliente].codiceCliente || dbClienti.value[props.idCliente].codice)) || String(props.idCliente || '');
		wsInt['C6'] = wsInt['C6'] || { t: 's', v: '' };
		wsInt['C6'].v = intestazioneCliente;
		aggiungiStileXls(wsInt['C6'], { font: { name: 'Arial', sz: 10 }, alignment: { wrapText: true, vertical: 'top' } });
		wsInt['!merges'].push({ s: { r: 34, c: 0 }, e: { r: 34, c: 2 } });
		wsInt['A35'] = wsInt['A35'] || { t: 's', v: '' };
		const sloganAzienda = "E F F I C I E N Z A    P E R    L E    G E N E R A Z I O N I    C H E    V E R R A N N O";
		wsInt['A35'].v = sloganAzienda;
		aggiungiStileXls(wsInt['A35'], { font: { name: 'Arial', sz: 12 }, alignment: { horizontal: 'center', vertical: 'center' } });
		wsInt['!rows'] = wsInt['!rows'] || [];
		wsInt['!rows'][5] = Object.assign(wsInt['!rows'][5] || {}, { hpt: 80 });
		XLSX.utils.book_append_sheet(wb, wsInt, 'Intestazione');

		Object.keys(sheetsData).forEach((si, nf) => {
			const rows = sheetsData[si];
			const ws = XLSX.utils.aoa_to_sheet(rows);
			ws['!cols'] = [
				{ width: 11 }, { width: 46 }, { width: 8 },
				{ width: 9 }, { width: 12 }, { width: 8 },
				{ width: 12 }
			];
			const totalRows = rows.length;
			applicaFontDefault(ws, 9);

			rows.forEach((row, i) => {
				const r = i + 1;

				if (i === 0) {
					ws['!merges'] = ws['!merges'] || [];
					ws['!merges'].push({ s: { r: 0, c: 1 }, e: { r: 0, c: 6 } });
					const a1 = ws['A1']; if (a1) aggiungiStileXls(a1, { font: { name: 'Arial', sz: 10, bold: true }, alignment: { horizontal: 'center', vertical: 'center' } });
					const b1 = ws['B1']; if (b1) { b1.v = String(b1.v || '').toUpperCase(); aggiungiStileXls(b1, { font: { name: 'Arial', sz: 10, bold: true }, alignment: { wrapText: true, vertical: 'center' } }); }
				}

				if (i === 1) {
					ws['!merges'] = ws['!merges'] || [];
					ws['!merges'].push({ s: { r: 1, c: 1 }, e: { r: 1, c: 6 } });
					const b2 = ws['B2']; if (b2) aggiungiStileXls(b2, { font: { name: 'Arial', sz: 10 }, alignment: { wrapText: true, vertical: 'top' } });
				}

				if (i === 3) {
					bodyHeader.forEach((_, c) => {
						const col = String.fromCharCode(65 + c);
						const cell = ws[col + r];
						if (cell) {
							aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10, bold: true }, border: { bottom: { style: 'thin', color: { rgb: 'FF000000' } } } });
							if (col !== 'B') aggiungiStileXls(cell, { alignment: { horizontal: 'center', vertical: 'center' } });
						}
					});
				}

				if (i > 3 && i <= ultimaRigaVoci[nf]) {
					['A', 'C', 'D', 'F'].forEach(col => {
						const cell = ws[col + r];
						if (cell) aggiungiStileXls(cell, { alignment: { horizontal: 'center', vertical: col === 'A' ? 'top' : 'bottom' } });
					});
					['A', 'B'].forEach(col => {
                        const cell = ws[col + r];
                        if (cell) aggiungiStileXls(cell, { alignment: { wrapText: true, vertical: 'top' } });
                    });
					['E', 'G'].forEach(col => {
						const cell = ws[col + r];
						if (cell && typeof cell.v === 'number') { cell.t = 'n'; cell.z = '#,##0.00'; }
					});
                    if (i <= ultimaRigaVoci[nf]-2){
                        ['A','B','C','D','E','F','G'].forEach(col => {
                            const ccell = ws[col + r] || (ws[col + r] = { t: 's', v: '' });
                            aggiungiStileXls(ccell, { border: { bottom: { style: 'thin', color: { rgb: 'FFE9E9E9' } } } });
                        });
                    } else if (i == ultimaRigaVoci[nf]) {
                        ['A','B','C','D','E','F','G'].forEach(col => {
                            const ccell = ws[col + r] || (ws[col + r] = { t: 's', v: '' });
                            aggiungiStileXls(ccell, { border: { bottom: { style: 'thin', color: { rgb: 'FF000000' } } } });
                        });
                    }
				}
				if (i > ultimaRigaVoci[nf] && i < totalRows - 1) {
					['A','B','C','D','E','F','G'].forEach(col => {
						const cell = ws[col + r];
                        if (cell) {
                            aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10 } });
                        }
					});
                }

				if (i === totalRows - 1) {
					['A','B','C','D','E','F','G'].forEach(col => {
						const cell = ws[col + r];
                        if (cell) {
                            aggiungiStileXls(cell, { border: { top: { style: 'thin', color: { rgb: 'FF000000' } } } });
                            aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10, bold: true } });
                        }
					});
				}
			});
            ws['!rows'] = ws['!rows'] || [];
            ws['!rows'][0] = Object.assign(ws['!rows'][0] || {}, { hpt: 35 });
            ws['!rows'][1] = Object.assign(ws['!rows'][1] || {}, { hpt: 100 });
			XLSX.utils.book_append_sheet(wb, ws, si.toString());
		});

		let quadroData = []
        const righeVuote = 21;
        for (let i = 0; i < righeVuote; i++) {
            quadroData.push(["", "", ""])
        }
        quadroData.push(["", "QUADRO SINTETICO", ""]);
        (elencoVociPreventivo.value || []).forEach((sezione, idxSez) => {
            quadroData.push(["", "", ""]);
            let rigaTotale = 2 + ultimaRigaVoci[idxSez];
            quadroData.push([ { t: 't', f: `+'${idxSez+1}'!$A$1` }, { t: 't', f: `+'${idxSez+1}'!$B$1` }, { t: 'n', f: `+'${idxSez+1}'!$G$${rigaTotale}`, z: '#,##0.00' }]);
        });
        quadroData.push(["", "", ""]);
        let aliquotaIva=0;
        switch (preventivoSelezionato.value.iva) {
            case 'Ordinaria 22%':
                aliquotaIva=0.22;
                break;
            case 'Manutenzione straord. 10%':
            case 'Ristrutturazione 10%':
                aliquotaIva=0.10;
                break;
            case 'IVA ridotta 4%':
                aliquotaIva=0.04;
                break;
            default:
                aliquotaIva=0;
        }
        switch (preventivoSelezionato.value.iva) {
            case 'Ordinaria 22%':
            case 'Manutenzione straord. 10%':
            case 'Ristrutturazione 10%':
            case 'IVA ridotta 4%':
                quadroData.push([
                    "", "TOTALE",
                    { t: 'n', f: `+SUM(C${righeVuote + 2}:C${quadroData.length-1})`, z: '#,##0.00' }
                ]);
                quadroData.push([
                    "",
                    `IVA ${aliquotaIva*100}%`,
                    { t: 'n', f: `C${quadroData.length}*${aliquotaIva}`, z: '#,##0.00' }
                ]);
                quadroData.push(["", "", ""]);
                quadroData.push([
                    "", "TOTALE IVA COMPRESA",
                    { t: 'n', f: `C${quadroData.length-2}+C${quadroData.length-1}`, z: '#,##0.00' }
                ]);
                break;
            default:
                quadroData.push([
                    "",
                    "TOTALE (iva esclusa)",
                    { t: 'n', f: `+SUM(C${righeVuote + 2}:C${quadroData.length-1})`, z: '#,##0.00' }
                ]);
        }

        const wsQuadro = XLSX.utils.aoa_to_sheet(quadroData);
        wsQuadro['!cols'] = [{ width: 12 }, { width: 78 }, { width: 14 }];
        XLSX.utils.book_append_sheet(wb, wsQuadro, 'Quadro');

        ['A','B','C'].forEach(col => {
            const cell = wsQuadro[col + (righeVuote+1)];
            if (cell) {
                aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10, bold: true }, alignment: { vertical: 'top' }, border: { bottom: { style: 'thin', color: { rgb: 'FF000000' } } } });
            }
        });
        const numRighe = aliquotaIva==0?quadroData.length:quadroData.length-3;
        for (let r = righeVuote+2; r < numRighe; r++) {
            ['A','B','C'].forEach(col => {
                const cell = wsQuadro[col + r];
                if (cell) {
                    if (r%2==0) {
                        if (r!=numRighe-2) {
                            aggiungiStileXls(cell, { border: { bottom: { style: 'thin', color: { rgb: 'FFE9E9E9' } } } });
                        }
                    }
                    if (r==numRighe-1) {
                        aggiungiStileXls(cell, { border: { bottom: { style: 'thin', color: { rgb: 'FF000000' } } } });
                    }
                    if (col==='A') {
                        aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10 }, alignment: { vertical: 'top', horizontal: 'center' } });
                    } else if (col==='B') {
                        aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10 }, alignment: { wrapText: true, vertical: 'top' } });
                    } else {
                        aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10 }, alignment: { vertical: 'bottom' } });
                    }
                }
            });
        }
        if (aliquotaIva!=0) {
            for (let r = numRighe; r < numRighe+3; r++) {
                ['A','B','C'].forEach(col => {
                    const cell = wsQuadro[col + r];
                    if (cell) {
                        if (col==='A') {
                            aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10 }, alignment: { vertical: 'top', horizontal: 'center' } });
                        } else if (col==='B') {
                            aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10 }, alignment: { wrapText: true, vertical: 'top' } });
                        } else {
                            aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10 }, alignment: { vertical: 'bottom' } });
                        }
                    }
                });
            }
        }
        ['A','B','C'].forEach(col => {
            const cell = wsQuadro[col + (quadroData.length)];
            if (cell) {
                aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10, bold: true }, alignment: { vertical: 'top' }, border: { top: { style: 'thin', color: { rgb: 'FF000000' } } } });
            }
        });

		let condizioniData = [
            ["CONDIZIONI GENERALI DI VENDITA"],
            [""],
            ["1 - Le presenti Condizioni Generali di Vendita sono parte integrante dell'Offerta presentata dalla ditta LMC srl al Cliente, e sono da considerarsi pienamente comprese e accettate da entrambe le parti con l'approvazione dell'Offerta in qualsiasi forma.\n" +
                "2 - In caso di discordanza tra le presenti Condizioni Generali e quanto indicato nell'Offerta prevalgono le indicazione contenute nell'Offerta. In caso di discordanza tra l'Offerta e la Conferma d'Ordine prevalgono le indicazioni contenute nella Conferma d'Ordine.\n" +
                "3 - Tutti gli importi si intendono in euro e non comprendono l'iva se non espressamente indicato.\n"],
            ["Condizioni della prestazione\n" +
                "4 - La LMC srl non potrà ritenersi responsabile per la variazione delle caratteristiche tecniche e della disponibilità dei prodotti offerti da parte delle ditte produttrici.\n" +
                "5 - Per i lavori in economia si applicherà la tariffa di 40,00 (quaranta/00) euro/ora/persona.\n" +
                "6 - Sono escluse le opere murarie, i ripristini e le tinteggiature che si dovessero rendere necessarie o utili durante i lavori o dopo la conclusione.\n" +
                "7 - Se non diversamente specificato gli impianti “sotto traccia” si intendono comprensivi della realizzazione delle tracce in laterizio, esclusa la chiusura delle stesse e la realizzazione di tracce nelle strutture in pietra o c.a.\n" +
                "8 - Sono comunque esclusi gli attraversamenti di strutture di spessore superiore ai 40 cm e/o di diametro superiore a 45 mm, nonchè la realizzazione di scassi, tracce ed attraversamenti per la realizzazione delle colonne montanti, delle colonne di scarico e dei passaggi per la realizzazione di canne fumarie.\n" +
                "9 - Sono esclusi gli scavi e tutte le opere murarie accessorie ancorché necessarie alla realizzazione degli impianti o a garantirne la sicurezza.\n" +
                "10 - Se non diversamente specificato è escluso lo smaltimento delle macerie e dei materiali risultanti dalla demolizione degli impianti esistenti.\n" +
                "11 - Dal montaggio dei sanitari è escluso il montaggio di box doccia, cabine, vasche idromassaggio, specchi, vetri e tende, accessori, mobili bagno, cappe aspiranti.\n" +
                "12 - Dal montaggio delle canne fumarie è esclusa, se non diversamente specificato, la fornitura e il montaggio di teste di camino, faldalerie, adattamenti e modifiche alla struttura di copertura, tegole e pezzi speciali del rivestimento.\n" +
                "13 - Le opere parzialmente o completamente realizzate in opera nonchè i materiali stoccati in cantiere o comunque sul luogo di installazione sono conservati ad onere e cura del Cliente che si occuperà di sorvegliare e vigilare affinchè non subiscano furti o danni di sorta. Il Cliente rimane responsabile in solido nei confronti della LMC srl per qualsiasi furto o danneggiamento, nonchè degli evenutali ritardi nell'avanzamento dei lavori conseguenti.\n"
            ],
            ["Messa in esercizio dell'impianto e Certificato di Conformità\n" +
                "14 - L'impianto si considera collaudato e in esercizio dopo il rilascio del Certificato di Conformità.\n" +
                "15 - Qualsiasi utilizzo o manovra dell'impianto effettuato dal Cliente prima del rilascio del Certificato di Conformità avviene a suo rischio e pericolo.\n" +
                "16 - Il Certificato di Conformità viene rilasciato esclusivamente a lavori completamente realizzati, dopo il collaudo da parte del personale della LMC srl e comunque dopo il pagamento del saldo.\n" +
                "17 - Il Certificato di Conformità non potrà essere rilasciato laddove, per ragioni non strettamente legate ai lavori oggetto dell'Offerta, non ci siano le condizioni per garantire la sicurezza degli impianti; ad esempio in caso di locali non ancora completamente realizzati o adeguati alla normativa vigente, in caso mancanza di porte o strutture REI dove richiesto dalla normativa vigente, in caso di mancanza di aperture di areazione o ventilazione, in presenza di parti di impianto esistenti non adeguate, ecc. In tutti questi casi il saldo dei lavori eseguiti sarà comunque dovuto.\n"
            ],
            ["Condizioni specifiche per impianti a pannelli radianti\n" +
                "18 - Lo spessore e la natura del massetto o dell'intonaco radiante, la disposizione dei giunti di dilatazione, la necessità e la modalità del ciclo di primo riscaldamento dovranno essere concordati con il massettista e il pavimentista, rimanendo sotto la responsabilità della LMC srl soltanto la corretta posa dei pannelli, tubi ed accessori, nonchè il rispetto del ciclo di primo riscaldamento concordato.\n" +
                "19 - Nella realizzazione dei sistemi a pannelli radianti è compresa la realizzazione del ciclo di primo riscaldamento con le apparecchiature presenti in loco (es. caldaia, pompa di calore, teleriscaldamento).\n" +
                "20 - In mancanza di apparecchiature di riscaldamento già presenti sarà possibile realizzare il riscaldamento con riscaldatore elettrico da 9 kW trifase al prezzo di 600,0 (seicento/00) euro. Per la realizzazione del riscaldamento con riscaldatore elettrico il Cliente dovrà rendere disponibile una fornitura elettrica adeguata a suo onere e spesa. Se si rendesse necessario effettuare cicli di riscaldamento a potenze superiori a 9 kW sarà necessario valutare e concordare preventivamente la possibilità tecnica e il prezzo della lavorazione.\n"
            ],
            ["Condizioni specifiche per impianti fotovoltaici\n" +
                "21 - Sono esclusi gli oneri richiesti dal gestore di rete.\n" +
                "22 - Il Cliente è tenuto a fornire tutti i documenti richiesti, in particolare la planimetria catastale in caso di allacciamento con Iter Ordinario.\n" +
                "23 - Le misurazioni di energia e corrente effettuate dal meter del sistema fotovoltaico possono differire significativamente dalle letture del contatore e, pertanto, hanno solamente scopo indicativo e sono funzionali al corretto funzionamento dell'impianto.\n" +
                "24 - Il Cliente è tenuto a verificare che il manto di copertura sia adeguato a sopportare il sovraccarico indotto dai pannelli fotovoltaici sia per quanto riguarda il peso sia la trazione generata dal vento. La LMC srl non potrà essere ritenuta responsabile in caso di cedimento strutturale del supporto (es. lamiere gracate, listellature, piccola orditura).\n" +
                "25 - Il Cliente è tenuto a verificare la presenza di vincoli paesaggistici. L'eventuale pratica per l'ottenimento dell'autorizzazione paesaggistica è a carico del Cliente.\n"
            ],
            ["Condizioni specifiche per il trattamento dei gas fluorurati\n" +
                "26 - La LMC srl è abilitata a trattare e recuperare i gas fluorurati.\n" +
                "27 - In caso di smontaggio o svuotamento di apparecchiature esistenti, se non diversamente specificato, la LMC srl lascerà presso il Cliente l'apparecchiatura smontata e sigillata ovvero una bombola sigillata da avviare a smaltimnto a cura, responsabilità ed onere del Cliente stesso.\n" +
                "28 - La LMC srl non può essere ritenuta responsabile per il mancato smaltimento dei gas lasciati al Cliente.\n"
            ],
            ["Condizioni specifiche per apparecchiature connesse a Internet\n" +
                "29 - La LMC srl vi assisterà direttamente o tramite l'intervento di un Centro Assistenza per la configurazione delle apparecchiature connesse a Internet a condizione che, al momento dell'avviamento, sia presente il Cliente o un suo delegato provvisto di apparecchiature idonee (es. tablet o smartphone) e sia disponibile l'allacciamento a internet tramite router correttamente configurato e con le necessarie porte aperte.\n" +
                "30 - La configurazione delle apparecchiature di accesso a internet (es. router, firewall) di proprietà del Cliente è comunque esclusa.\n" +
                "31 - Dopo l'avviamento tutte le successive riconfigurazioni saranno eseguite dal Centro Assistenza di riferimento e saranno a carico del Cliente.\n"
            ],
            ["Condizioni di garanzia\n" +
                "32 - Tutti i prodotti venduti e i lavori effettuati dalla ditta LMC srl sono coperti da garanzia legale di 2 anni per qualsiasi difetto di produzione o installazione. La garanzia decorre dalla data del Certificato di Conformità o, in assenza, dalla data di fatturazione. Condizioni di garanzia diverse possono essere indicate in offerta.\n" +
                "33 - Garanzie estese sono offerte direttamente dalle case produttrici. Per i dettagli di tali garanzie riferirsi direttamente ai documenti forniti dalle case produttrici stesse. La LMC srl non è responsabile di eventuali variazioni nelle condizioni di garanzia fornite da terzi o difformità da quanto indicato in Offerta.\n" +
                "34 - Nessuna garanzia è dovuta per danni causati da uso inidoneo e improprio, da montaggio, o messa in funzione scorretti da parte di terzi, da usura normale, da trattamento improprio o negligente, da dispositivi inidonei per il funzionamento o in seguito ad un uso continuato dopo il verificarsi dei disturbi, dall'errata scelta del bruciatore o dalla taratura scorretta dello stesso, da combustibili inidonei e da influssi chimici, elettrochimici o elettrici da inosservanza delle istruzioni per il montaggio, il funzionamento e la manutenzione nonché da modifiche o lavori di manutenzione impropri, se non riconducibili ai lavori effettuati dalla ditta LMC srl. La garanzia non copre i danni cagionati a cose o persone.\n" +
                "35 - La garanzia non copre in nessun caso i mancati guadagni o i danni indiretti derivanti dal fermo impianti e dalla indisponibilità del servizio.\n" +
                "36 - Sono esclusi dalla garanzia i costi per le opere provvisionali, delle rotture e successivi ripristini necessarie all'accesso a impianti installati in condizioni inidonee (es. unità esterne delle pompe di calore in copertura), e/o privi delle necessarie ispezioni (es. collettori incassati nelle murature).\n" +
                "37 - La LMC srl si riserva il diritto di sostituire con prodotti analoghi, riparare o modificare i materiali o gli impianti risultati difettosi o non conformi.\n"
            ],
            ["Condizioni di pagamento\n" +
                "38 - L'IVA è sempre a carico del cliente secondo le disposizioni di legge vigenti. L'applicazione dell'aliquota agevolata al 10% per manutenzioni e ristrutturazioni su immobili residenziali è subordinata alla firma di una liberatoria; in mancanza della stessa è comunque dovuta l'IVA secondo l'aliquota ordinaria.\n" +
                "39 - In caso di ritardato pagamento si applicheranno le spese di riscossione nella misura fissa di 5,00 (cinque/00) euro fino al quindicesimo giorno di ritardo.\n" +
                "40 - In caso di ritardato pagamento oltre il quindicesimo giorno si applicheranno gli interessi legali oltre che le spese legali e di riscossione effettivamente sostenute.\n"
            ],
            ["Detrazioni fiscali e altre agevolazioni\n" +
                "41 - Per i lavori che usufruiscono di detrazioni fiscali o altre agevolazioni statali il Cliente è tenuto a verificare le condizioni soggettive per l'applicazione delle stesse e rimane responsabile per tutte le condizioni che non riguardano strettamente le caratteristiche tecniche dei prodotti e dei sistemi installati direttamente dalla LMC srl.\n" +
                "42 - Per i lavori che usufruiscono delle detrazioni fiscali o delle altre agevolazioni il Cliente è tenuto a segnalare le circostanze alla LMC srl indicando chiaramente eventuali requisiti specifici.\n" +
                "43 - Se non diversamente indicato sono escluse le spese tecniche per l'accesso alle agevolazioni.\n"
            ],
            ["Validità dell'offerta\n" +
                "44 - L'offerta ha validità di 30 giorni se non diversamente specificato.\n" +
                "45 - L'offerta è sempre soggetta a verifica di fattibilità tecnica.\n"
            ],
            ["Foro competente\n" +
                "46 - Per qualsiasi controversia relativa alla validità, interpretazione, esecuzione e risoluzione del presente contratto, sarà competente in via esclusiva il Foro di Ivrea.\n"
            ],
            [""],
            ["Per accettazione"],
            [""],
            ["Luogo e data: _____________________________________"],
            ["il cliente"],
            [""],
            [""],
            [""],
            [""],
            [""],
            ["_____________________________________"]
        ]
        const wsCondizioni = XLSX.utils.aoa_to_sheet(condizioniData);
        wsCondizioni['!cols'] = [{ width: 105 }];
		aggiungiStileXls(wsCondizioni['A1'], { font: { name: 'Arial', sz: 9, bold: true  } });
        for (let i = 2; i < (condizioniData.length-9); i++) {
            aggiungiStileXls(wsCondizioni['A' + i], { font: { name: 'Arial', sz: 8 }, alignment: { wrapText: true, vertical: 'top', horizontal: "justify"} });
        }
        const rigaFirma = condizioniData.length-6
		aggiungiStileXls(wsCondizioni['A' + rigaFirma], { alignment: { horizontal: "right", indent: 11} });
		aggiungiStileXls(wsCondizioni['A' + (rigaFirma+6)], { alignment: { horizontal: "right"} });
        XLSX.utils.book_append_sheet(wb, wsCondizioni, 'Condizioni');

		XLSX.writeFile(wb, nomeFile, { bookType: 'xlsx', cellStyles: true });
	}

	function scaricaXlsxOrdine() {
        let nomeFile = 'O-';
        if (preventivoSelezionato.value.data) {
            nomeFile += dataDaTimestamp(preventivoSelezionato.value.data, 'anno');
        } else {
            const d = new Date();
            nomeFile += d.getFullYear();
        }
        nomeFile += '-';
        if (preventivoSelezionato.value.numero) {
            nomeFile += padNumero(preventivoSelezionato.value.numero,3);
        } else {
            nomeFile += 'XXX';
        }
        nomeFile += ' -';
        if (dbClienti.value[props.idCliente]) {
            if (dbClienti.value[props.idCliente].nome) {
                nomeFile += ' ' + dbClienti.value[props.idCliente].nome;
            }
            if (dbClienti.value[props.idCliente].cognome) {
                nomeFile += ' ' + dbClienti.value[props.idCliente].cognome;
            }
        }
        if (preventivoSelezionato.value.oggetto) {
            nomeFile += ' - ' + preventivoSelezionato.value.oggetto;
        }
        nomeFile += ' - ';
        if (preventivoSelezionato.value.data) {
            nomeFile += dataDaTimestamp(preventivoSelezionato.value.data, 'testoAAAA-MM-GG');
        } else {
            const d = new Date();
            nomeFile += d.getFullYear() + '-' + padNumero((d.getMonth() + 1), 2) + '-' + padNumero(d.getDate(), 2);
        }
		nomeFile += '.xlsx';

		const wb = XLSX.utils.book_new();

		let intestazioneCliente = dbClienti.value[props.idCliente]?.nome ? ( dbClienti.value[props.idCliente].nome + ' ' ) : '' ;
        intestazioneCliente += dbClienti.value[props.idCliente]?.cognome || "";
        let headerData = [
			["ORDINE DI LAVORO", ""],
			["", ""],
			["Cliente", intestazioneCliente],
			["Cod. lavoro", (dbClienti.value[props.idCliente]?.codice || "") +" - __________"],
			["Preventivo n.", ( preventivoSelezionato.value.data?dataDaTimestamp(preventivoSelezionato.value.data, 'anno'):"______" ) + '/' + ( preventivoSelezionato.value.numero?padNumero(preventivoSelezionato.value.numero, 3):"____" )],
			// FIX: Estrazione protetta da optional chaining
            ["Data ordine", dbClienti.value[props.idCliente]?.leads?.[props.idLead]?.finalizzazioneData ? dataDaTimestamp(dbClienti.value[props.idCliente].leads[props.idLead].finalizzazioneData, 'testo'):""],
			["Indirizzo", dbClienti.value[props.idCliente]?.leads?.[props.idLead]?.indirizzo || ""],
			["Posizione", formatCoordinate(dbClienti.value[props.idCliente]?.leads?.[props.idLead]?.luogo || "")]
		];
        if (preventivoSelezionato.value.riferimento) {
            headerData.push(["Riferimento", preventivoSelezionato.value.riferimento?preventivoSelezionato.value.riferimento:""]);
        }
        const nRigheIntestazione = headerData.length;
        headerData.push(
            ["", ""],
            ["CONTATTI", ""],
            ["", ""]
        );
        // FIX: Protezione su Object.keys
        const leadContatti = dbClienti.value[props.idCliente]?.leads?.[props.idLead]?.contatti || {};
        Object.keys(leadContatti).forEach(cnt => {
            let stringaContatto = "";
            if (dbContatti.value[cnt]) {
                if (dbContatti.value[cnt].nome) stringaContatto += dbContatti.value[cnt].nome;
                if (dbContatti.value[cnt].cognome) {
                    if (stringaContatto.length > 0) stringaContatto += " ";
                    stringaContatto += dbContatti.value[cnt].cognome;
                }
                stringaContatto += " (" + leadContatti[cnt].ruolo + ")";
                    headerData.push(["", stringaContatto]);
                if (dbContatti.value[cnt].telefono){
                    headerData.push(
                        ["Telefono", formattaTelefono(dbContatti.value[cnt].telefono)]
                    );
                }
                if (dbContatti.value[cnt].telefono2){
                    headerData.push(
                        ["Telefono", formattaTelefono(dbContatti.value[cnt].telefono2)]
                    );
                }
            }
        });
        const nRigheContatti = headerData.length;

        headerData.push(
            ["", ""],
            ["NOTE", ""],
            ["", ""],
            ["", ""]
        );

		const wsInt = XLSX.utils.aoa_to_sheet(headerData);
		wsInt["!cols"] = [{ width: 18 }, { width: 67 }];
		wsInt['!rows'] = wsInt['!rows'] || [];
		applicaFontDefault(wsInt, 10);
		wsInt['!merges'] = wsInt['!merges'] || [];
		wsInt['!merges'].push({ s: { r: 0, c: 0 }, e: { r: 0, c: 1 } });     
		wsInt['!merges'].push({ s: { r: headerData.length-1, c: 0 }, e: { r: headerData.length-1, c: 1 } });     
		aggiungiStileXls(wsInt['A1'], { font: { name: 'Arial', sz: 12 }, alignment: { horizontal: 'center', vertical: 'center' } });

        for (let i = 0; i < headerData.length; i++) {
            const r = i + 1;
            wsInt['!rows'][i] = Object.assign(wsInt['!rows'][i] || {}, {  hpt: 25 });
            ['A', 'B'].forEach(col => {
                const cell = wsInt[col + r];
                if (cell) aggiungiStileXls(cell, { height: 25, font: { name: 'Arial', sz: 12 }, alignment: { vertical: 'center' } });
            });
        }
        for (let i = 0; i < nRigheContatti; i++) {
            const r = i + 1;
            if (r > 2 && r <= nRigheIntestazione) {
                ['A', 'B'].forEach(col => {
                    const cell = wsInt[col + r];
                    if (cell) aggiungiStileXls(cell, { border: { bottom: { style: 'thin', color: { rgb: 'FFE9E9E9' } } } });
                });
            }
            if (r > nRigheIntestazione+3) {
                if (headerData[i][0]!="Telefono") {
                    ['A', 'B'].forEach(col => {
                        const cell = wsInt[col + r];
                        if (cell) aggiungiStileXls(cell, { border: { top: { style: 'thin', color: { rgb: 'FFE9E9E9' } } } });
                    });
                }
                if (r==nRigheContatti) {
                    ['A', 'B'].forEach(col => {
                        const cell = wsInt[col + r];
                        if (cell) aggiungiStileXls(cell, { border: { bottom: { style: 'thin', color: { rgb: 'FFE9E9E9' } } } });
                    });
                }
            }
        }
        ['A', 'B'].forEach(col => {
            const cell = wsInt[col + (headerData.length)];
            if (cell) aggiungiStileXls(cell, { border: { top: { style: 'thin', color: { rgb: 'FFE9E9E9' } }, bottom: { style: 'thin', color: { rgb: 'FFE9E9E9' } } }, alignment: { vertical: 'top' } });
        });
        wsInt['!rows'][headerData.length-1] = Object.assign(wsInt['!rows'][headerData.length-1] || {}, {  hpt: 150 });

		XLSX.utils.book_append_sheet(wb, wsInt, 'Intestazione');

		const bodyHeader = ["Codice", "Descrizione", "Unità", "Quantità", "Consuntivo"];
		const sheetsData = {};

		(elencoVociPreventivo.value || []).forEach((sezione, idxSez) => {
			const rows = [];
			const vt = Array.isArray(sezione) ? sezione.find(v => v && v.tipo === 'Titolo') : null;
			const codiceTitolo = vt && vt.codice ? vt.codice : "";
			const titoloUp = vt && vt.titolo ? String(vt.titolo).toUpperCase() : "";
			const sottotitolo = vt && vt.sottotitolo ? vt.sottotitolo : "";
			rows.push([codiceTitolo, titoloUp]);
			rows.push(["", sottotitolo]);
			rows.push(["", "", "", "", ""]);
			rows.push(bodyHeader);
			(sezione || []).forEach(ev => {
				if (ev && ev.tipo === 'Articolo') {
					rows.push([
						ev.codice,
						ev.descrizione,
						ev.unita,
						ev.quantita,
						""
					]);
				}
			});
			sheetsData[idxSez + 1] = rows;
		});

		Object.keys(sheetsData).forEach((si) => {
			const rows = sheetsData[si];
			const ws = XLSX.utils.aoa_to_sheet(rows);
			ws['!cols'] = [
				{ width: 10 }, { width: 45 }, { width: 6 },
				{ width: 12 }, { width: 12 }
			];
			const totalRows = rows.length;
			applicaFontDefault(ws, 9);

			rows.forEach((row, i) => {
				const r = i + 1;
				if (i === 0) {
					ws['!merges'] = ws['!merges'] || [];
					ws['!merges'].push({ s: { r: 0, c: 1 }, e: { r: 0, c: 4 } });
					const a1 = ws['A1']; if (a1) aggiungiStileXls(a1, { font: { name: 'Arial', sz: 10, bold: true }, alignment: { horizontal: 'center', vertical: 'center' } });
					const b1 = ws['B1']; if (b1) { b1.v = String(b1.v || '').toUpperCase(); aggiungiStileXls(b1, { font: { name: 'Arial', sz: 10, bold: true }, alignment: { wrapText: true, vertical: 'center' } }); }
				}
				if (i === 1) {
					ws['!merges'] = ws['!merges'] || [];
					ws['!merges'].push({ s: { r: 1, c: 1 }, e: { r: 1, c: 4 } });
					const b2 = ws['B2']; if (b2) aggiungiStileXls(b2, { alignment: { wrapText: true, vertical: 'top' } });
				}
				if (i === 3) {
					bodyHeader.forEach((_, c) => {
						const col = String.fromCharCode(65 + c);
						const cell = ws[col + r];
						if (cell) {
							aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10, bold: true }, border: { bottom: { style: 'thin', color: { rgb: 'FF000000' } } } });
							if (col !== 'B') aggiungiStileXls(cell, { alignment: { horizontal: 'center', vertical: 'center' } });
						}
					});
				}
				if (i > 3 && i <= totalRows) {
					['A', 'C', 'D'].forEach(col => {
						const cell = ws[col + r];
						if (cell) aggiungiStileXls(cell, { alignment: { horizontal: 'center', vertical: col === 'A' ? 'top' : 'bottom' } });
					});
					['A', 'B'].forEach(col => {
                        const cell = ws[col + r];
                        if (cell) aggiungiStileXls(cell, { alignment: { wrapText: true, vertical: 'top' } });
                    });
                    if (i <= totalRows){
                        ['A','B','C','D','E'].forEach(col => {
                            const ccell = ws[col + r] || (ws[col + r] = { t: 's', v: '' });
                            aggiungiStileXls(ccell, { border: { bottom: { style: 'thin', color: { rgb: 'FFE9E9E9' } } } });
                        });
                    }
				}

			});
            ws['!rows'] = ws['!rows'] || [];
            ws['!rows'][0] = Object.assign(ws['!rows'][0] || {}, { hpt: 35 });
            ws['!rows'][1] = Object.assign(ws['!rows'][1] || {}, { hpt: 100 });
			XLSX.utils.book_append_sheet(wb, ws, si.toString());
		});

		XLSX.writeFile(wb, nomeFile, { bookType: 'xlsx', cellStyles: true });
	}

	function scaricaXlsxConsuntivo() {
        let nomeFile = 'C-';
        if (preventivoSelezionato.value.data) {
            nomeFile += dataDaTimestamp(preventivoSelezionato.value.data, 'anno');
        } else {
            const d = new Date();
            nomeFile += d.getFullYear();
        }
        nomeFile += '-';
        if (preventivoSelezionato.value.numero) {
            nomeFile += padNumero(preventivoSelezionato.value.numero,3);
        } else {
            nomeFile += 'XXX';
        }
        nomeFile += ' -';
        if (dbClienti.value[props.idCliente]) {
            if (dbClienti.value[props.idCliente].nome) {
                nomeFile += ' ' + dbClienti.value[props.idCliente].nome;
            }
            if (dbClienti.value[props.idCliente].cognome) {
                nomeFile += ' ' + dbClienti.value[props.idCliente].cognome;
            }
        }
        if (preventivoSelezionato.value.oggetto) {
            nomeFile += ' - ' + preventivoSelezionato.value.oggetto;
        }
        nomeFile += ' - ';
        if (preventivoSelezionato.value.data) {
            nomeFile += dataDaTimestamp(preventivoSelezionato.value.data, 'testoAAAA-MM-GG');
        } else {
            const d = new Date();
            nomeFile += d.getFullYear() + '-' + padNumero((d.getMonth() + 1), 2) + '-' + padNumero(d.getDate(), 2);
        }
		nomeFile += '.xlsx';

		const wb = XLSX.utils.book_new();

		let intestazioneCliente = dbClienti.value[props.idCliente]?.nome ? ( dbClienti.value[props.idCliente].nome + ' ' ) : '' ;
        intestazioneCliente += dbClienti.value[props.idCliente]?.cognome || "";
        let rows = [
			["CONSUNTIVO FORNITURE E LAVORI"],
			[""],
			["Data:  "],
			["Cliente:  " + intestazioneCliente],
			["Cod. lavoro:  " + (dbClienti.value[props.idCliente]?.codice || "") + " - __________"],
			// FIX: Accesso protetto
            ["Indirizzo: " + (dbClienti.value[props.idCliente]?.leads?.[props.idLead]?.indirizzo || "")],
		];
        if (preventivoSelezionato.value.riferimento) {
            rows.push(["Riferimento:  " + preventivoSelezionato.value.riferimento?preventivoSelezionato.value.riferimento:""]);
        }
        rows.push(["Rif. preventivo n.:  " + ( preventivoSelezionato.value.data?dataDaTimestamp(preventivoSelezionato.value.data, 'anno'):"______" ) + '/' + ( preventivoSelezionato.value.numero?padNumero(preventivoSelezionato.value.numero, 3):"____" )]);
        rows.push("");
        const nRigheIntestazione = rows.length;

		rows.push(["", "", "", "Preventivo", "", "", "Consuntivo", "", ""]);
		rows.push(["Codice", "Descrizione", "Unità", "Unitario", "Q.", "Totale", "Unitario", "Q.", "Totale"]);
        let stringaSommePreventivo = "";
        let stringaSommeConsuntivo = "";
        (elencoVociPreventivo.value || []).forEach((sezione) => {
            let righeSezione = 0;       
            if (Array.isArray(sezione)) {
                righeSezione = sezione.filter(v => v && v.tipo === 'Articolo').length;
            }
			const vt = Array.isArray(sezione) ? sezione.find(v => v && v.tipo === 'Titolo') : null;
			const codiceTitolo = vt && vt.codice ? vt.codice : "";
			const titoloUp = vt && vt.titolo ? String(testoPrimaDiAcapo(vt.titolo)).toUpperCase() : "";
            stringaSommePreventivo += `+SUM(F${rows.length+2}:F${rows.length+1+righeSezione})`;
            stringaSommeConsuntivo += `+SUM(I${rows.length+2}:I${rows.length+1+righeSezione})`;
			rows.push([
                codiceTitolo,
                titoloUp,
                "",
                "",
                "",
                { t: 'n', f: `+SUM(F${rows.length+2}:F${rows.length+1+righeSezione})`, z: '#,##0.00' },
                "",
                "",
                { t: 'n', f: `+SUM(I${rows.length+2}:I${rows.length+1+righeSezione})`, z: '#,##0.00' }
            ]);
			(sezione || []).forEach(ev => {
				if (ev && ev.tipo === 'Articolo') {
					rows.push([
						ev.codice,
						testoPrimaDiAcapo(ev.descrizione),
						ev.unita,
						{ t: 't', f: `+${prezzoVocePreventivo(ev, preventivoSelezionato.value.sconti[ev.tipoRicaricoSconto])}`, z: '#,##0.00' },
						ev.quantita,
                       { t: 't', f: `+D${rows.length+1}*E${rows.length+1}`, z: '#,##0.00' },
                       { t: 't', f: `+D${rows.length+1}`, z: '#,##0.00' },
                       "",
                       { t: 'n', f: `+IF(H${rows.length+1}<>"",G${rows.length+1}*H${rows.length+1},"")`, z: '#,##0.00' }
					]);
				}
			});
		});
        
        const numRighe = 6;
        stringaSommePreventivo += `+SUM(F${rows.length+2}:F${rows.length+2+numRighe-1})`;
        stringaSommeConsuntivo += `+SUM(I${rows.length+2}:I${rows.length+2+numRighe-1})`;
        rows.push([
            "",
            "LAVORI NON A PREVENTIVO",
            "",
            "",
            "",
            "",
            "",
            "",
            { t: 'n', f: `+SUM(I${rows.length+2}:I${rows.length+2+numRighe-1})`, z: '#,##0.00' }
        ]);
        for (let i = 0; i < numRighe; i++) {
            rows.push([
                "",
                "",
                "",
                "",
                "",
                "",
                { t: 't', f: `0`, z: '#,##0.00' },
                "",
                { t: 'n', f: `+IF(H${rows.length+1}<>"",G${rows.length+1}*H${rows.length+1},"")`, z: '#,##0.00' }
            ]);
        }
        rows.push(["","","","","","","","",""]);
        rows.push([
            "",
            "TOTALE (euro iva esclusa)",
            "",
            "",
            "",
            { t: 'n', f: stringaSommePreventivo, z: '#,##0.00' },
            "",
            "",
            { t: 'n', f: stringaSommeConsuntivo, z: '#,##0.00'},
        ]);
		const ws = XLSX.utils.aoa_to_sheet(rows);
		ws["!cols"] = [
            { width: 15 },
            { width: 54 },
            { width: 7 },
            { width: 10 },
            { width: 6 },
            { width: 10 },
            { width: 10 },
            { width: 7 },
            { width: 10 }
        ];
		ws['!rows'] = ws['!rows'] || [];
		applicaFontDefault(ws, 10);
		ws['!merges'] = ws['!merges'] || [];
		ws['!merges'].push({ s: { r: 0, c: 0 }, e: { r: 0, c: 8 } });
		aggiungiStileXls(ws['A1'], { font: { name: 'Arial', sz: 12, bold: true }, alignment: { horizontal: 'center', vertical: 'center' } });
		ws['!merges'].push({ s: { r: 8, c: 3 }, e: { r: 8, c: 5 } });
		ws['!merges'].push({ s: { r: 8, c: 7 }, e: { r: 6, c: 8 } });
		aggiungiStileXls(ws['D9'], { font: { name: 'Arial', sz: 10, bold: true }, alignment: { horizontal: 'center', vertical: 'center' } });
		aggiungiStileXls(ws['G9'], { font: { name: 'Arial', sz: 10, bold: true }, alignment: { horizontal: 'center', vertical: 'center' } });
        ['A'].forEach(col => {
            const cell = ws[col + 10];
            aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10, bold: true }, alignment: { horizontal: 'center' } });
        });
        ['B'].forEach(col => {
            const cell = ws[col + 10];
            aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10, bold: true } });
        });
        ['C', 'D', 'E', 'E', 'F', 'G', 'H', 'I'].forEach(col => {
            const cell = ws[col + 10];
            aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10, bold: true }, alignment: { horizontal: 'center', vertical: 'center' } });
        });
        ['A','B','C', 'D', 'E', 'E', 'F', 'G', 'H', 'I'].forEach(col => {
            const cell =  ws[col + 10];
            aggiungiStileXls(cell, { border: { bottom: { style: 'thin', color: { rgb: 'FF000000' } } } });
        });
        let riga = nRigheIntestazione+3; 
        for (let sz=0; sz < elencoVociPreventivo.value.length; sz++) {
            for (let vc=0; vc < elencoVociPreventivo.value[sz].length; vc++) {
                if (elencoVociPreventivo.value[sz][vc].tipo === 'Titolo') {
                    ['A'].forEach(col => {
                        const cell = ws[col + (riga)];
                        aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10, bold: true }, alignment: { horizontal: 'center', verticalvertical: 'bottom' }});
                    });
                    ['B', 'F', 'I'].forEach(col => {
                        const cell = ws[col + (riga)];
                        aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10, bold: true }, alignment: { wrapText: true, vertical: 'bottom' }});
                    });
                    ['A','B','C', 'D', 'E', 'E', 'F', 'G', 'H', 'I'].forEach(col => {
                        const cell = ws[col + (riga)];
                        aggiungiStileXls(cell, { border: { bottom: { style: 'thin', color: { rgb: 'FFE9E9E9' } } } });
                    });
                    ws['!rows'][riga-1] = Object.assign(ws['!rows'][riga-1] || {}, {  hpt: 25 });
                    riga++;
                }
                if (elencoVociPreventivo.value[sz][vc].tipo === 'Articolo') {
                    ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'].forEach(col => {
                        const cell = ws[col + (riga)];
                        aggiungiStileXls(cell, { font: { name: 'Arial', sz: 9 }, border: { bottom: { style: 'thin', color: { rgb: 'FFE9E9E9' } } } });
                    });
                    ['A','C', 'E', 'H'].forEach(col => {
                        const cell = ws[col + (riga)];
                        aggiungiStileXls(cell, { alignment: { horizontal: 'center' } });
                    });
                    riga++;
                }
            }
        }
        ['A', 'B', 'F', 'I'].forEach(col => {
            const cell = ws[col + (riga)];
            aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10, bold: true }, alignment: { wrapText: true, vertical: 'bottom' } });
        });
        ['A','B','C', 'D', 'E', 'E', 'F', 'G', 'H', 'I'].forEach(col => {
            const cell = ws[col + (riga)];
            aggiungiStileXls(cell, { border: { bottom: { style: 'thin', color: { rgb: 'FFE9E9E9' } } } });
        });
        for (let i = 1; i < numRighe+1; i++) {
            ['A'].forEach(col => {
                const cell = ws[col + (riga+i)];
                aggiungiStileXls(cell, { font: { name: 'Arial', sz: 9}, border: { bottom: { style: 'thin', color: { rgb: 'FFE9E9E9' } } }, alignment: { horizontal: 'center' } });
            });
            ['B','C', 'D', 'E', 'E', 'F', 'G', 'H', 'I'].forEach(col => {
                const cell = ws[col + (riga+i)];
                aggiungiStileXls(cell, { font: { name: 'Arial', sz: 9}, border: { bottom: { style: 'thin', color: { rgb: 'FFE9E9E9' } } } });
            });
        }
        ws['!rows'][riga-1] = Object.assign(ws['!rows'][riga-1] || {}, {  hpt: 25 });
        ['A','B','C', 'D', 'E', 'E', 'F', 'G', 'H', 'I'].forEach(col => {
            const cell = ws[col + rows.length];
            aggiungiStileXls(cell, { font: { name: 'Arial', sz: 10, bold: true }, border: { top: { style: 'thin', color: { rgb: 'FF000000' } } } });
        });
        for (let i = nRigheIntestazione; i < rows.length+1; i++) {
            ['C', 'F'].forEach(col => {
                const cell = ws[col + (i)];
                aggiungiStileXls(cell, { border: { right: { style: 'thin', color: { rgb: 'FFE9E9E9' } } } });
            });
        }

		XLSX.utils.book_append_sheet(wb, ws, 'Consuntivo');

		XLSX.writeFile(wb, nomeFile, { bookType: 'xlsx', cellStyles: true });
	}

	function padNumero(numero, numCaratteri) {
		let numStr = String(numero);
        while (numStr.length < numCaratteri) {
            numStr = '0' + numStr;
        }
        return numStr;
	}

	function aggiungiStileXls(cell, patch) {
		if (!cell) return;
		cell.s = deepMerge(cell.s || {}, patch);
	}

	function deepMerge(a, b) {
		const out = { ...(a || {}) };
		for (const [k, v] of Object.entries(b || {})) {
			if (v && typeof v === 'object' && !Array.isArray(v)) {
				out[k] = deepMerge(out[k], v);
			} else {
				out[k] = v;
			}
		}
		return out;
	}

	function applicaFontDefault(ws, sz = 9) {
		for (const key of Object.keys(ws)) {
			if (key[0] === '!') continue;
			const cell = ws[key];
			if (cell) aggiungiStileXls(cell, { font: { name: 'Arial', sz } });
		}
	}

    function formatCoordinate(str) {
        if (!str) return "";
        const parti = str.split(",");
        if (parti.length < 2) return "";
        const lat = parseFloat(parti[0].trim());
        const lon = parseFloat(parti[1].trim());
        if (isNaN(lat) || isNaN(lon)) return "";
        return `${lat.toFixed(4)}, ${lon.toFixed(4)}`;
    }

    function testoPrimaDiAcapo(str) {
        if (!str) return "";
        const index = str.indexOf('\n');
        if (index === -1) return str.trim();   
        return str.slice(0, index).trim();
    }

</script>